// Dealer Portal translations — 25 European country codes
// Auto-detect from dealer country or manual selector
// Fallback chain: selected language -> UK-English (safe non-IT fallback)
//                 change request keys merged in from ./dealerChangeRequests

import { CHANGE_REQUESTS_I18N } from './dealerChangeRequests';

const DEALER_TRANSLATIONS = {
  IT: {
    // Login
    portalTitle: "Portale Dealer", loginSubtitle: "Accedi per gestire i tuoi clienti", email: "Email", password: "Password", login: "Accedi", forgotPassword: "Password dimenticata?",
    // Roles
    dealer: "DEALER", seller: "VENDITORE",
    // Customer-list scope (Fabrizio CR 26/02/2026)
    scopeMineLabel: "Solo i miei", scopeAllLabel: "Tutti del dealer", assignedTo: "Assegnato a", assignedToManager: "Cliente del manager",
    // Tabs
    dashboard: "Dashboard", newCustomer: "Nuovo Cliente", myCustomers: "Elenco Clienti", sellers: "Venditori", backOffice: "Back-Office", report: "Report", manuals: "Manuali", security: "Sicurezza",
    // Dashboard stats
    totalCustomers: "Clienti Totali", emailsSent: "Email Inviate", termsAccepted: "Termini Accettati", contractsSigned: "Contratti Firmati", cardsCreated: "Card Create", last30days: "Ultimi 30gg",
    startAdding: "Inizia inserendo un nuovo cliente",
    // Target
    monthlyTarget: "Obiettivo Mensile", targetReached: "Obiettivo raggiunto! Ottimo lavoro!", remainingClients: "clienti rimanenti per raggiungere l'obiettivo",
    // Leaderboard
    leaderboard: "Classifica", youAreAt: "Sei al", place: "posto", you: "Tu", clients: "clienti", contracts: "contratti",
    // Digest
    weeklyDigest: "Digest Settimanale", digestDescription: "Ricevi un riepilogo via email ogni lunedi alle 8:00", sendPreview: "Invia Anteprima", sending: "Invio...",
    digestEnabled: "Digest settimanale attivato", digestDisabled: "Digest settimanale disattivato", digestSent: "Digest di anteprima inviato alla tua email!",
    // New customer form
    phone: "Cellulare", vehicleBrand: "Marca Veicolo", vehicleModel: "Modello Veicolo", vin: "VIN (Telaio)", vrn: "VRN (Targa)", country: "Paese", serviceType: "Servizio LJ Acquistato",
    verifyAndCreate: "Verifica e Crea Cliente", creating: "Creazione...",
    // Confirm modal
    confirmTitle: "Conferma Dati Cliente", confirmSubtitle: "Verifica che i dati inseriti siano corretti prima di procedere:", brand: "Marca", model: "Modello", service: "Servizio",
    edit: "Modifica", confirmAndSend: "Conferma e Invia",
    // Customer created
    customerCreated: "Cliente creato! Email di benvenuto inviata.", createError: "Errore nella creazione", vinAlreadyEnrolled: "VIN già registrato nel sistema",
    vinAlreadyEnrolledTitle: "VIN già registrato",
    vinAlreadyEnrolledBody: "Il VIN {vin} risulta già registrato nel sistema. Un veicolo non può essere associato a due clienti diversi.",
    existingCustomerLabel: "Cliente esistente", createdOnLabel: "Creato il", contractStatusLabel: "Contratto",
    signedLabel: "Firmato", pendingSignatureLabel: "In attesa di firma",
    vinDupeOtherDealer: "Il veicolo è registrato presso un altro concessionario. Contatta il supporto LoJack se ritieni si tratti di un errore.",
    changeVinBtn: "Modifica VIN", openExistingCustomerBtn: "Apri scheda cliente",
    // My customers
    refresh: "Aggiorna", noCustomers: "Nessun cliente inserito", signed: "Firmato", card: "Card",
    // Sellers
    newSeller: "Nuovo Venditore", addSeller: "Aggiungi Venditore", close: "Chiudi",
    sellerEmailInfo: "Il venditore ricevera un'email con il link per creare la sua password.",
    firstName: "Nome", lastName: "Cognome", phoneSeller: "Telefono", department: "Reparto",
    createSeller: "Crea Venditore e Invia Email", noSellers: "Nessun venditore registrato",
    clickToAdd: "Clicca \"Nuovo Venditore\" per aggiungere un membro del team.",
    sellerCreated: "Venditore creato! Email di attivazione inviata.", sellerCreateError: "Errore nella creazione del venditore",
    activation: "Attivazione", active: "Attivo", pending: "In attesa", deactivated: "Account disattivato",
    sellerActivated: "Venditore attivato", sellerDeactivated: "Venditore disattivato",
    activationResent: "Email di attivazione re-inviata!", deleteSeller: "Eliminare il venditore", deleteConfirm: "Questa azione e' irreversibile.", sellerDeleted: "Venditore eliminato",
    // Back-Office (Zorzutti CR 12 Feb 2026 — separate menu item)
    newBackOffice: "Nuovo Back-Office", addBackOffice: "Aggiungi Back-Office",
    createBackOffice: "Crea Back-Office e Invia Email",
    backOfficeEmailInfo: "L'utenza Back-Office ricevera un'email con il link per creare la sua password. Le utenze Back-Office possono inserire clienti per conto dei venditori e monitorare tutti i contratti, ma non appaiono nel dropdown \"Venditore associato\" ne vedono statistiche di performance.",
    backOfficeCreated: "Utenza Back-Office creata! Email di attivazione inviata.",
    noBackOffice: "Nessuna utenza Back-Office registrata",
    clickToAddBackOffice: "Clicca \"Nuovo Back-Office\" per aggiungere personale amministrativo.",
    // Report
    sellersReport: "Report Venditori", globalTarget: "Obiettivo Globale Mensile", globalTargetDesc: "Target di default per tutti i venditori (sovrascrivibile singolarmente)",
    clientsMonth: "clienti/mese", target: "Obiettivo", monthProgress: "Progresso Mese", total: "Totale",
    performanceBySeller: "Performance per Venditore", noTarget: "Nessun obiettivo",
    targetUpdated: "Obiettivo globale aggiornato", customTarget: "Obiettivo personalizzato", targetRemoved: "Obiettivo rimosso (usa globale)",
    directCustomers: "Clienti Diretti", sellerCount: "Venditori",
    monthlyLeaderboard: "Classifica Mensile", noSellersReport: "Nessun venditore registrato per generare il report.",
    loadingReport: "Caricamento report...", clickRefresh: "Clicca \"Aggiorna\" per caricare il report.",
    // Notifications
    notifications: "Notifiche", markAllRead: "Segna tutte lette", noNotifications: "Nessuna notifica",
    // Errors
    loginError: "Errore di login", saveError: "Errore nel salvataggio", sendError: "Errore nell'invio", toggleError: "Errore nel cambio stato", deleteError: "Errore nella cancellazione",
    // Language
    language: "Lingua",
    // Footer
    poweredBy: "Powered by TelcaVoIP AI Engine",
  },
  UK: {
    portalTitle: "Dealer Portal", loginSubtitle: "Log in to manage your customers", email: "Email", password: "Password", login: "Log in", forgotPassword: "Forgot password?",
    dealer: "DEALER", seller: "SELLER",
    dashboard: "Dashboard", newCustomer: "New Customer", myCustomers: "My Customers", sellers: "Sellers", backOffice: "Back-Office", report: "Report", manuals: "Manuals", security: "Security",
    // Customer-list scope (Fabrizio CR 26/02/2026)
    scopeMineLabel: "Only mine", scopeAllLabel: "All of the dealer", assignedTo: "Assigned to", assignedToManager: "Manager's customer",
    totalCustomers: "Total Customers", emailsSent: "Emails Sent", termsAccepted: "Terms Accepted", contractsSigned: "Contracts Signed", cardsCreated: "Cards Created", last30days: "Last 30 days",
    startAdding: "Start by adding a new customer",
    monthlyTarget: "Monthly Target", targetReached: "Target reached! Great job!", remainingClients: "clients remaining to reach the target",
    leaderboard: "Leaderboard", youAreAt: "You are in", place: "place", you: "You", clients: "clients", contracts: "contracts",
    weeklyDigest: "Weekly Digest", digestDescription: "Receive a summary email every Monday at 8:00", sendPreview: "Send Preview", sending: "Sending...",
    digestEnabled: "Weekly digest enabled", digestDisabled: "Weekly digest disabled", digestSent: "Preview digest sent to your email!",
    phone: "Mobile", vehicleBrand: "Vehicle Brand", vehicleModel: "Vehicle Model", vin: "VIN (Chassis)", vrn: "VRN (Plate)", country: "Country", serviceType: "LJ Service Purchased",
    verifyAndCreate: "Verify and Create Customer", creating: "Creating...",
    confirmTitle: "Confirm Customer Data", confirmSubtitle: "Please verify the data before proceeding:", brand: "Brand", model: "Model", service: "Service",
    edit: "Edit", confirmAndSend: "Confirm and Send",
    customerCreated: "Customer created! Welcome email sent.", createError: "Creation error", vinAlreadyEnrolled: "VIN already enrolled in the system",
    vinAlreadyEnrolledTitle: "VIN already enrolled",
    vinAlreadyEnrolledBody: "VIN {vin} is already enrolled in the system. A vehicle cannot be associated with two different customers.",
    existingCustomerLabel: "Existing customer", createdOnLabel: "Created on", contractStatusLabel: "Contract",
    signedLabel: "Signed", pendingSignatureLabel: "Pending signature",
    vinDupeOtherDealer: "This vehicle is registered at another dealer. Please contact LoJack support if you believe this is an error.",
    changeVinBtn: "Change VIN", openExistingCustomerBtn: "Open customer record",
    refresh: "Refresh", noCustomers: "No customers added", signed: "Signed", card: "Card",
    newSeller: "New Seller", addSeller: "Add Seller", close: "Close",
    sellerEmailInfo: "The seller will receive an email with a link to create their password.",
    firstName: "First Name", lastName: "Last Name", phoneSeller: "Phone", department: "Department",
    createSeller: "Create Seller and Send Email", noSellers: "No sellers registered",
    clickToAdd: "Click \"New Seller\" to add a team member.",
    sellerCreated: "Seller created! Activation email sent.", sellerCreateError: "Error creating seller",
    activation: "Activation", active: "Active", pending: "Pending", deactivated: "Account deactivated",
    sellerActivated: "Seller activated", sellerDeactivated: "Seller deactivated",
    activationResent: "Activation email resent!", deleteSeller: "Delete seller", deleteConfirm: "This action is irreversible.", sellerDeleted: "Seller deleted",
    newBackOffice: "New Back-Office", addBackOffice: "Add Back-Office",
    createBackOffice: "Create Back-Office and Send Email",
    backOfficeEmailInfo: "The Back-Office user will receive an email with a link to create their password. Back-Office users can enter customers on behalf of sellers and monitor all contracts, but they do not appear in the \"Credited seller\" dropdown nor see performance statistics.",
    backOfficeCreated: "Back-Office user created! Activation email sent.",
    noBackOffice: "No Back-Office users registered",
    clickToAddBackOffice: "Click \"New Back-Office\" to add administrative staff.",
    sellersReport: "Sellers Report", globalTarget: "Global Monthly Target", globalTargetDesc: "Default target for all sellers (can be overridden individually)",
    clientsMonth: "clients/month", target: "Target", monthProgress: "Month Progress", total: "Total",
    performanceBySeller: "Performance by Seller", noTarget: "No target",
    targetUpdated: "Global target updated", customTarget: "Custom target", targetRemoved: "Target removed (uses global)",
    directCustomers: "Direct Customers", sellerCount: "Sellers",
    monthlyLeaderboard: "Monthly Leaderboard", noSellersReport: "No sellers registered to generate a report.",
    loadingReport: "Loading report...", clickRefresh: "Click \"Refresh\" to load the report.",
    notifications: "Notifications", markAllRead: "Mark all read", noNotifications: "No notifications",
    loginError: "Login error", saveError: "Save error", sendError: "Send error", toggleError: "Toggle error", deleteError: "Delete error",
    // ─── auto-translated 2026-06-23 (UI fallback rescue) ───
    enterValidNumber: "Enter a valid number",
    walletQrTitle: "Wallet link  QR ready to display",
    walletQrSmsModeBody: "The customer in this country receives the card via SMS. Show this QR to the customer to open the wallet on their phone immediately  without waiting for the message.",
    walletQrBothModeBody: "Email and SMS sent. If the customer is in front of you, they can scan this QR to open the card immediately.",
    walletQrShortLinkLabel: "Short link (for WhatsApp / chat)",
    walletQrCopied: "Link copied",
    walletQrCopyBtn: "Copy",
    walletQrSmsRecipient: "SMS sent to",
    walletQrEmailRecipient: "Email sent to",
    walletQrDoneBtn: "Close",
    cannotDeleteContractSigned: "Cannot delete: contract already signed",
    confirmDeleteCustomer: "Delete customer {name} ({email})?",
    customerDeletedSuccess: "Customer deleted",
    customerDeleteError: "Customer deletion error",
    contractNotSignedYet: "Contract not yet signed by customer",
    signedPdfDownloaded: "Signed PDF downloaded",
    signedPdfDownloadError: "Signed PDF download error",
    viewSignedReadonly: "View data (signed, read-only)",
    editCustomer: "Edit customer",
    downloadSignedPdf: "Download signed contract (PDF)",
    deleteCustomerOnlyUnsigned: "Delete customer (only if unsigned)",
    vinApplied: "VIN recognised",
    phoneCountryMismatchTitle: "Number from another country detected",
    phoneCountryMismatchBody: "The telephone code indicates a {detected} customer, but the customer country is currently {current}. Do you want to update it?",
    phoneCountrySwitchedTo: "Customer country updated:",
    phoneCountrySwitchTo: "Set country to {detected}",
    vatCountryMismatchTitle: "VAT from another country detected",
    vatCountryMismatchBody: "The VAT prefix indicates a {detected} customer, but the customer country is currently {current}. Do you want to update it?",
    vatCountrySwitchedTo: "Customer country updated:",
    vatCountrySwitchTo: "Set country to {detected}",
    vehicleOriginLabel: "Vehicle",
    vinAutoApplied: "Vehicle recognised  auto-filled",
    vinEditable: "The Make and Model fields can still be edited.",
    vrnOptional: "Optional field",
    sellerCreditedLabel: "Associated seller",
    sellerCreditedPlaceholder: "Select seller...",
    sellerCreditedManagerSuffix: "Owner",
    sellerCreditedHintNoSellers: "You have not yet added sellers. You can assign this customer to yourself or create one from the \"Sellers\" tab.",
    deactivateAction: "Deactivate",
    activateAction: "Activate",
    salesTeamPlaceholder: "e.g. North Sales",
    resendActivationEmail: "Re-send activation email",
    deleteAction: "Delete",
    manual: "Operating Manual",
    mismatchSourceVat: "from VAT",
    mismatchSourcePhone: "from phone",
    mismatchCorrectionReasonDefault: "Corrected by Mismatch widget (dealer)",
    mismatchCountryUpdated: "Country updated:",
    mismatchCorrectionFailed: "Correction error",
    mismatchCleanTitle: "Country data quality: Good work",
    mismatchCleanBody: "All {n} customers in the last 30 days have the country consistent with VAT/phone.",
    mismatchTitle: "Customers with country to review",
    mismatchBodyIntro: "In the last 30 days you have created",
    mismatchBodyMiddle: "customers, of which",
    mismatchBodyEnd: "have a different country from the one suggested by VAT or telephone code. Fix with one click.",
    mismatchCurrent: "Current:",
    mismatchFixBtn: "Fix",
    mismatchConfirmQuestion: "Confirm country change to",
    mismatchReasonPlaceholder: "Correction reason (optional)",
    mismatchSaving: "Saving...",
    mismatchConfirmFix: "Confirm correction",
    mismatchCancel: "Cancel",
    language: "Language", poweredBy: "Powered by TelcaVoIP AI Engine",
  },
  FR: {
    portalTitle: "Portail Concessionnaire", loginSubtitle: "Connectez-vous pour gerer vos clients", email: "E-mail", password: "Mot de passe", login: "Se connecter", forgotPassword: "Mot de passe oublie?",
    dealer: "CONCESSIONNAIRE", seller: "VENDEUR",
    dashboard: "Tableau de bord", newCustomer: "Nouveau Client", myCustomers: "Mes Clients", sellers: "Vendeurs", backOffice: "Back-Office", report: "Rapport", manuals: "Manuels", security: "Sécurité",
    // Customer-list scope (Fabrizio CR 26/02/2026)
    scopeMineLabel: "Seulement les miens", scopeAllLabel: "Tous du dealer", assignedTo: "Attribué à", assignedToManager: "Client du manager",
    totalCustomers: "Clients Totaux", emailsSent: "E-mails envoyés", termsAccepted: "Conditions acceptées", contractsSigned: "Contrats signés", cardsCreated: "Cartes créées", last30days: "30 derniers jours",
    startAdding: "Commencez par ajouter un nouveau client",
    monthlyTarget: "Objectif Mensuel", targetReached: "Objectif atteint! Excellent travail!", remainingClients: "clients restants pour atteindre l'objectif",
    leaderboard: "Classement", youAreAt: "Vous êtes au", place: "rang", you: "Vous", clients: "clients", contracts: "contrats",
    weeklyDigest: "Résumé Hebdomadaire", digestDescription: "Recevez un résumé par e-mail chaque lundi à 8h00", sendPreview: "Envoyer Aperçu", sending: "Envoi...",
    digestEnabled: "Résumé hebdomadaire activé", digestDisabled: "Résumé hebdomadaire désactivé", digestSent: "Aperçu du résumé envoyé à votre e-mail!",
    phone: "Mobile", vehicleBrand: "Marque du Véhicule", vehicleModel: "Modèle du Véhicule", vin: "VIN (Châssis)", vrn: "Immatriculation", country: "Pays", serviceType: "Service LJ Acheté",
    verifyAndCreate: "Vérifier et Créer le Client", creating: "Création...",
    confirmTitle: "Confirmer les Données Client", confirmSubtitle: "Vérifiez les données avant de continuer:", brand: "Marque", model: "Modèle", service: "Service",
    edit: "Modifier", confirmAndSend: "Confirmer et Envoyer",
    customerCreated: "Client créé! E-mail de bienvenue envoyé.", createError: "Erreur de création", vinAlreadyEnrolled: "VIN déjà enregistré dans le système",
    refresh: "Actualiser", noCustomers: "Aucun client ajouté", signed: "Signé", card: "Carte",
    newSeller: "Nouveau Vendeur", addSeller: "Ajouter un Vendeur", close: "Fermer",
    sellerEmailInfo: "Le vendeur recevra un e-mail avec un lien pour créer son mot de passe.",
    firstName: "Prénom", lastName: "Nom", phoneSeller: "Téléphone", department: "Service",
    createSeller: "Créer Vendeur et Envoyer E-mail", noSellers: "Aucun vendeur enregistré",
    clickToAdd: "Cliquez \"Nouveau Vendeur\" pour ajouter un membre de l'équipe.",
    sellerCreated: "Vendeur créé! E-mail d'activation envoyé.", sellerCreateError: "Erreur de création du vendeur",
    activation: "Activation", active: "Actif", pending: "En attente", deactivated: "Compte désactivé",
    sellerActivated: "Vendeur activé", sellerDeactivated: "Vendeur désactivé",
    activationResent: "E-mail d'activation renvoyé!", deleteSeller: "Supprimer le vendeur", deleteConfirm: "Cette action est irréversible.", sellerDeleted: "Vendeur supprimé",
    newBackOffice: "Nouvel utilisateur back-office", addBackOffice: "Ajouter un utilisateur back-office",
    createBackOffice: "Créer un utilisateur back-office et envoyer e-mail",
    backOfficeEmailInfo: "L'utilisateur Back-Office recevra un e-mail avec un lien pour créer son mot de passe. Les utilisateurs Back-Office peuvent saisir des clients pour le compte des vendeurs et surveiller tous les contrats, mais n'apparaissent pas dans la liste \"Vendeur associe\" et ne voient pas les statistiques de performance.",
    backOfficeCreated: "Utilisateur back-office créé ! E-mail d'activation envoyé.",
    noBackOffice: "Aucun utilisateur back-office enregistré",
    clickToAddBackOffice: "Cliquez \"Nouveau Back-Office\" pour ajouter du personnel administratif.",
    sellersReport: "Rapport Vendeurs", globalTarget: "Objectif Mensuel Global", globalTargetDesc: "Objectif par defaut pour tous les vendeurs (modifiable individuellement)",
    clientsMonth: "clients/mois", target: "Objectif", monthProgress: "Progrès du Mois", total: "Total",
    performanceBySeller: "Performance par Vendeur", noTarget: "Pas d'objectif",
    targetUpdated: "Objectif global mis à jour", customTarget: "Objectif personnalisé", targetRemoved: "Objectif supprimé (utilise le global)",
    directCustomers: "Clients Directs", sellerCount: "Vendeurs",
    monthlyLeaderboard: "Classement Mensuel", noSellersReport: "Aucun vendeur enregistré pour générer un rapport.",
    loadingReport: "Chargement du rapport...", clickRefresh: "Cliquez \"Actualiser\" pour charger le rapport.",
    notifications: "Notifications", markAllRead: "Tout marquer comme lu", noNotifications: "Aucune notification",
    loginError: "Erreur de connexion", saveError: "Erreur de sauvegarde", sendError: "Erreur d'envoi", toggleError: "Erreur de basculement", deleteError: "Erreur de suppression",
    // ─── auto-translated 2026-06-23 (UI fallback rescue) ───
    enterValidNumber: "Saisir un numéro valide",
    vinAlreadyEnrolledTitle: "VIN déjà enregistré",
    vinAlreadyEnrolledBody: "Le VIN {vin} est déjà enregistré dans le système. Un véhicule ne peut pas être associe a deux clients differents.",
    existingCustomerLabel: "Client existant",
    createdOnLabel: "Créé le",
    contractStatusLabel: "Contrat",
    signedLabel: "Signé",
    pendingSignatureLabel: "En attente de signature",
    vinDupeOtherDealer: "Le véhicule est enregistré chez un autre concessionnaire. Contacter le support LoJack si vous pensez qu'il s'agit d'une erreur.",
    changeVinBtn: "Modifier VIN",
    openExistingCustomerBtn: "Ouvrir fiche client",
    walletQrTitle: "Lien wallet  QR pret a afficher",
    walletQrSmsModeBody: "Le client dans ce pays recoit la carte par SMS. Montrer ce QR au client pour ouvrir immediatement le wallet sur son téléphone  sans attendre le message.",
    walletQrBothModeBody: "Email et SMS envoyés. Si le client est devant vous, il peut scanner ce QR pour ouvrir la carte immediatement.",
    walletQrShortLinkLabel: "Lien court (pour WhatsApp / chat)",
    walletQrCopied: "Lien copie",
    walletQrCopyBtn: "Copier",
    walletQrSmsRecipient: "SMS envoyé à",
    walletQrEmailRecipient: "Email envoyé à",
    walletQrDoneBtn: "Fermer",
    cannotDeleteContractSigned: "Impossible de supprimer : contrat déjà signé",
    confirmDeleteCustomer: "Supprimer le client {name} ({email})?",
    customerDeletedSuccess: "Client supprimé",
    customerDeleteError: "Erreur suppression client",
    contractNotSignedYet: "Contrat pas encore signé par le client",
    signedPdfDownloaded: "PDF signé telecharge",
    signedPdfDownloadError: "Erreur telechargement PDF signé",
    viewSignedReadonly: "Visualiser données (signé, lecture seule)",
    editCustomer: "Modifier client",
    downloadSignedPdf: "Telecharger contrat signé (PDF)",
    deleteCustomerOnlyUnsigned: "Supprimer client (uniquement si non signé)",
    vinApplied: "VIN reconnu",
    phoneCountryMismatchTitle: "Numéro d'un autre pays detecte",
    phoneCountryMismatchBody: "L'indicatif telephonique indique un client {detected}, mais le pays du client est actuellement {current}. Voulez-vous le mettre a jour?",
    phoneCountrySwitchedTo: "Pays client mis à jour :",
    phoneCountrySwitchTo: "Definir pays sur {detected}",
    vatCountryMismatchTitle: "TVA d'un autre pays detectee",
    vatCountryMismatchBody: "Le prefixe de la TVA indique un client {detected}, mais le pays du client est actuellement {current}. Voulez-vous le mettre a jour?",
    vatCountrySwitchedTo: "Pays client mis à jour :",
    vatCountrySwitchTo: "Definir pays sur {detected}",
    vehicleOriginLabel: "Véhicule",
    vinAutoApplied: "Véhicule reconnu  rempli automatiquement",
    vinEditable: "Les champs Marque et Modèle restent modifiables.",
    vrnOptional: "Champ facultatif",
    sellerCreditedLabel: "Vendeur associe",
    sellerCreditedPlaceholder: "Selectionner le vendeur...",
    sellerCreditedManagerSuffix: "Titulaire",
    sellerCreditedHintNoSellers: "Vous n'avez pas encore ajouté de vendeurs. Vous pouvez attribuer ce client a vous-meme ou en créer un depuis l'onglet \"Vendeurs\".",
    deactivateAction: "Desactiver",
    activateAction: "Activer",
    salesTeamPlaceholder: "ex. Ventes Nord",
    resendActivationEmail: "Renvoyer email activation",
    deleteAction: "Supprimer",
    manual: "Manuel Operatoire",
    mismatchSourceVat: "de TVA",
    mismatchSourcePhone: "de téléphone",
    mismatchCorrectionReasonDefault: "Corrige par le widget Mismatch (concessionnaire)",
    mismatchCountryUpdated: "Pays mis à jour :",
    mismatchCorrectionFailed: "Erreur correction",
    mismatchCleanTitle: "Qualite données pays :  Excellent travail",
    mismatchCleanBody: "Tous les {n} clients des 30 derniers jours ont le pays coherent avec TVA/téléphone.",
    mismatchTitle: "Clients avec pays a revoir",
    mismatchBodyIntro: "Au cours des 30 derniers jours vous avez créé",
    mismatchBodyMiddle: "clients, dont",
    mismatchBodyEnd: "ont un pays different de celui suggere par TVA ou indicatif telephonique. Corriger en un clic.",
    mismatchCurrent: "Actuel :",
    mismatchFixBtn: "Corriger",
    mismatchConfirmQuestion: "Confirmer changement pays vers",
    mismatchReasonPlaceholder: "Motif correction (facultatif)",
    mismatchSaving: "Enregistrement...",
    mismatchConfirmFix: "Confirmer correction",
    mismatchCancel: "Annuler",
    language: "Langue", poweredBy: "Powered by TelcaVoIP AI Engine",
  },
  ES: {
    portalTitle: "Portal Distribuidor", loginSubtitle: "Accede para gestionar tus clientes", email: "Email", password: "Contrasena", login: "Acceder", forgotPassword: "Contrasena olvidada?",
    dealer: "DISTRIBUIDOR", seller: "VENDEDOR",
    dashboard: "Panel", newCustomer: "Nuevo Cliente", myCustomers: "Mis Clientes", sellers: "Vendedores", backOffice: "Back-Office", report: "Informe", manuals: "Manuales", security: "Seguridad",
    // Customer-list scope (Fabrizio CR 26/02/2026)
    scopeMineLabel: "Solo los míos", scopeAllLabel: "Todos del dealer", assignedTo: "Asignado a", assignedToManager: "Cliente del manager",
    totalCustomers: "Clientes Totales", emailsSent: "Emails Enviados", termsAccepted: "Terminos Aceptados", contractsSigned: "Contratos Firmados", cardsCreated: "Tarjetas Creadas", last30days: "Ultimos 30 dias",
    startAdding: "Comienza agregando un nuevo cliente",
    monthlyTarget: "Objetivo Mensual", targetReached: "Objetivo alcanzado! Excelente!", remainingClients: "clientes restantes para alcanzar el objetivo",
    leaderboard: "Clasificacion", youAreAt: "Estas en el", place: "puesto", you: "Tu", clients: "clientes", contracts: "contratos",
    weeklyDigest: "Resumen Semanal", digestDescription: "Recibe un resumen por email cada lunes a las 8:00", sendPreview: "Enviar Vista Previa", sending: "Enviando...",
    digestEnabled: "Resumen semanal activado", digestDisabled: "Resumen semanal desactivado", digestSent: "Resumen de vista previa enviado a tu email!",
    phone: "Movil", vehicleBrand: "Marca del Vehiculo", vehicleModel: "Modelo del Vehiculo", vin: "VIN (Chasis)", vrn: "Matricula", country: "Pais", serviceType: "Servicio LJ Adquirido",
    verifyAndCreate: "Verificar y Crear Cliente", creating: "Creando...",
    confirmTitle: "Confirmar Datos del Cliente", confirmSubtitle: "Verifica los datos antes de continuar:", brand: "Marca", model: "Modelo", service: "Servicio",
    edit: "Modificar", confirmAndSend: "Confirmar y Enviar",
    customerCreated: "Cliente creado! Email de bienvenida enviado.", createError: "Error en la creacion", vinAlreadyEnrolled: "VIN ya registrado en el sistema",
    refresh: "Actualizar", noCustomers: "Ningun cliente agregado", signed: "Firmado", card: "Tarjeta",
    newSeller: "Nuevo Vendedor", addSeller: "Agregar Vendedor", close: "Cerrar",
    sellerEmailInfo: "El vendedor recibira un email con el enlace para crear su contrasena.",
    firstName: "Nombre", lastName: "Apellido", phoneSeller: "Telefono", department: "Departamento",
    createSeller: "Crear Vendedor y Enviar Email", noSellers: "Ningun vendedor registrado",
    clickToAdd: "Haz clic en \"Nuevo Vendedor\" para agregar un miembro del equipo.",
    sellerCreated: "Vendedor creado! Email de activacion enviado.", sellerCreateError: "Error al crear el vendedor",
    activation: "Activacion", active: "Activo", pending: "Pendiente", deactivated: "Cuenta desactivada",
    sellerActivated: "Vendedor activado", sellerDeactivated: "Vendedor desactivado",
    activationResent: "Email de activacion reenviado!", deleteSeller: "Eliminar vendedor", deleteConfirm: "Esta accion es irreversible.", sellerDeleted: "Vendedor eliminado",
    newBackOffice: "Nuevo Back-Office", addBackOffice: "Agregar Back-Office",
    createBackOffice: "Crear Back-Office y Enviar Email",
    backOfficeEmailInfo: "El usuario Back-Office recibira un email con el enlace para crear su contrasena. Los usuarios Back-Office pueden registrar clientes en nombre de los vendedores y monitorizar todos los contratos, pero no aparecen en el desplegable \"Vendedor asociado\" ni ven estadisticas de rendimiento.",
    backOfficeCreated: "Usuario Back-Office creado! Email de activacion enviado.",
    noBackOffice: "Ningun usuario Back-Office registrado",
    clickToAddBackOffice: "Haz clic en \"Nuevo Back-Office\" para agregar personal administrativo.",
    sellersReport: "Informe de Vendedores", globalTarget: "Objetivo Mensual Global", globalTargetDesc: "Objetivo por defecto para todos los vendedores (modificable individualmente)",
    clientsMonth: "clientes/mes", target: "Objetivo", monthProgress: "Progreso del Mes", total: "Total",
    performanceBySeller: "Rendimiento por Vendedor", noTarget: "Sin objetivo",
    targetUpdated: "Objetivo global actualizado", customTarget: "Objetivo personalizado", targetRemoved: "Objetivo eliminado (usa global)",
    directCustomers: "Clientes Directos", sellerCount: "Vendedores",
    monthlyLeaderboard: "Clasificacion Mensual", noSellersReport: "Ningun vendedor registrado para generar un informe.",
    loadingReport: "Cargando informe...", clickRefresh: "Haz clic en \"Actualizar\" para cargar el informe.",
    notifications: "Notificaciones", markAllRead: "Marcar todo leido", noNotifications: "Sin notificaciones",
    loginError: "Error de acceso", saveError: "Error al guardar", sendError: "Error al enviar", toggleError: "Error al cambiar estado", deleteError: "Error al eliminar",
    // ─── auto-translated 2026-06-23 (UI fallback rescue) ───
    enterValidNumber: "Introduce un numero valido",
    vinAlreadyEnrolledTitle: "VIN ya registrado",
    vinAlreadyEnrolledBody: "El VIN {vin} ya esta registrado en el sistema. Un vehiculo no puede estar asociado a dos clientes distintos.",
    existingCustomerLabel: "Cliente existente",
    createdOnLabel: "Creado el",
    contractStatusLabel: "Contrato",
    signedLabel: "Firmado",
    pendingSignatureLabel: "Pendiente de firma",
    vinDupeOtherDealer: "El vehiculo esta registrado en otro concesionario. Contacta con soporte LoJack si crees que es un error.",
    changeVinBtn: "Modificar VIN",
    openExistingCustomerBtn: "Abrir ficha cliente",
    walletQrTitle: "Link wallet - QR listo para mostrar",
    walletQrSmsModeBody: "El cliente en este pais recibe la tarjeta por SMS. Muestra este QR al cliente para abrir el wallet en su telefono inmediatamente, sin esperar el mensaje.",
    walletQrBothModeBody: "Email y SMS enviados. Si el cliente esta delante de ti, puede escanear este QR para abrir la tarjeta inmediatamente.",
    walletQrShortLinkLabel: "Link corto (para WhatsApp / chat)",
    walletQrCopied: "Link copiado",
    walletQrCopyBtn: "Copiar",
    walletQrSmsRecipient: "SMS enviado a",
    walletQrEmailRecipient: "Email enviado a",
    walletQrDoneBtn: "Cerrar",
    cannotDeleteContractSigned: "Imposible eliminar: contrato ya firmado",
    confirmDeleteCustomer: "Eliminar el cliente {name} ({email})?",
    customerDeletedSuccess: "Cliente eliminado",
    customerDeleteError: "Error al eliminar cliente",
    contractNotSignedYet: "Contrato aun no firmado por el cliente",
    signedPdfDownloaded: "PDF firmado descargado",
    signedPdfDownloadError: "Error al descargar PDF firmado",
    viewSignedReadonly: "Ver datos (firmado, solo lectura)",
    editCustomer: "Modificar cliente",
    downloadSignedPdf: "Descargar contrato firmado (PDF)",
    deleteCustomerOnlyUnsigned: "Eliminar cliente (solo si no firmado)",
    vinApplied: "VIN reconocido",
    phoneCountryMismatchTitle: "Numero de otro pais detectado",
    phoneCountryMismatchBody: "El prefijo telefonico indica un cliente {detected}, pero el pais del cliente es actualmente {current}. Quieres actualizarlo?",
    phoneCountrySwitchedTo: "Pais cliente actualizado:",
    phoneCountrySwitchTo: "Establecer pais en {detected}",
    vatCountryMismatchTitle: "NIF de otro pais detectado",
    vatCountryMismatchBody: "El prefijo del NIF indica un cliente {detected}, pero el pais del cliente es actualmente {current}. Quieres actualizarlo?",
    vatCountrySwitchedTo: "Pais cliente actualizado:",
    vatCountrySwitchTo: "Establecer pais en {detected}",
    vehicleOriginLabel: "Vehiculo",
    vinAutoApplied: "Vehiculo reconocido - completado automaticamente",
    vinEditable: "Los campos Marca y Modelo son modificables.",
    vrnOptional: "Campo opcional",
    sellerCreditedLabel: "Vendedor asociado",
    sellerCreditedPlaceholder: "Selecciona el vendedor...",
    sellerCreditedManagerSuffix: "Titular",
    sellerCreditedHintNoSellers: "Aun no has anadido vendedores. Puedes atribuir este cliente a ti mismo o crear uno desde la pestana \"Vendedores\".",
    deactivateAction: "Desactivar",
    activateAction: "Activar",
    salesTeamPlaceholder: "ej. Ventas Norte",
    resendActivationEmail: "Reenviar email activacion",
    deleteAction: "Eliminar",
    manual: "Manual Operativo",
    mismatchSourceVat: "de NIF",
    mismatchSourcePhone: "de telefono",
    mismatchCorrectionReasonDefault: "Corregido desde widget Mismatch (concesionario)",
    mismatchCountryUpdated: "Pais actualizado:",
    mismatchCorrectionFailed: "Error correccion",
    mismatchCleanTitle: "Calidad datos pais:  Excelente trabajo",
    mismatchCleanBody: "Todos los {n} clientes de los ultimos 30 dias tienen el pais coherente con NIF/telefono.",
    mismatchTitle: "Clientes con pais a revisar",
    mismatchBodyIntro: "En los ultimos 30 dias has creado",
    mismatchBodyMiddle: "clientes, de los cuales",
    mismatchBodyEnd: "tienen un pais diferente al sugerido por NIF o prefijo telefonico. Corrige con un click.",
    mismatchCurrent: "Actual:",
    mismatchFixBtn: "Corregir",
    mismatchConfirmQuestion: "Confirma cambio pais a",
    mismatchReasonPlaceholder: "Motivo correccion (opcional)",
    mismatchSaving: "Guardando...",
    mismatchConfirmFix: "Confirmar correccion",
    mismatchCancel: "Cancelar",
    language: "Idioma", poweredBy: "Powered by TelcaVoIP AI Engine",
  },
  DE: {
    portalTitle: "Handler-Portal", loginSubtitle: "Melden Sie sich an, um Ihre Kunden zu verwalten", email: "E-Mail", password: "Passwort", login: "Anmelden", forgotPassword: "Passwort vergessen?",
    dealer: "HANDLER", seller: "VERKAUFER",
    dashboard: "Dashboard", newCustomer: "Neuer Kunde", myCustomers: "Meine Kunden", sellers: "Verkaufer", backOffice: "Back-Office", report: "Bericht", manuals: "Handbucher", security: "Sicherheit",
    // Customer-list scope (Fabrizio CR 26/02/2026)
    scopeMineLabel: "Nur meine", scopeAllLabel: "Alle des Händlers", assignedTo: "Zugewiesen an", assignedToManager: "Kunde des Managers",
    totalCustomers: "Kunden Gesamt", emailsSent: "E-Mails Gesendet", termsAccepted: "Bedingungen Akzeptiert", contractsSigned: "Vertrage Unterzeichnet", cardsCreated: "Karten Erstellt", last30days: "Letzte 30 Tage",
    startAdding: "Beginnen Sie mit einem neuen Kunden",
    monthlyTarget: "Monatsziel", targetReached: "Ziel erreicht! Grossartig!", remainingClients: "Kunden bis zum Ziel",
    leaderboard: "Rangliste", youAreAt: "Sie sind auf", place: "Platz", you: "Sie", clients: "Kunden", contracts: "Vertrage",
    weeklyDigest: "Wochentliche Zusammenfassung", digestDescription: "Erhalten Sie jeden Montag um 8:00 Uhr eine Zusammenfassung per E-Mail", sendPreview: "Vorschau Senden", sending: "Senden...",
    digestEnabled: "Wochentliche Zusammenfassung aktiviert", digestDisabled: "Wochentliche Zusammenfassung deaktiviert", digestSent: "Vorschau an Ihre E-Mail gesendet!",
    phone: "Mobil", vehicleBrand: "Fahrzeugmarke", vehicleModel: "Fahrzeugmodell", vin: "FIN (Fahrgestell)", vrn: "Kennzeichen", country: "Land", serviceType: "LJ-Service",
    verifyAndCreate: "Prufen und Kunde Erstellen", creating: "Erstellen...",
    confirmTitle: "Kundendaten Bestatigen", confirmSubtitle: "Uberprufen Sie die Daten bevor Sie fortfahren:", brand: "Marke", model: "Modell", service: "Service",
    edit: "Bearbeiten", confirmAndSend: "Bestatigen und Senden",
    customerCreated: "Kunde erstellt! Willkommens-E-Mail gesendet.", createError: "Fehler beim Erstellen", vinAlreadyEnrolled: "VIN bereits im System registriert",
    refresh: "Aktualisieren", noCustomers: "Keine Kunden hinzugefugt", signed: "Unterschrieben", card: "Karte",
    newSeller: "Neuer Verkaufer", addSeller: "Verkaufer Hinzufugen", close: "Schliessen",
    sellerEmailInfo: "Der Verkaufer erhalt eine E-Mail mit einem Link zur Passworterstellung.",
    firstName: "Vorname", lastName: "Nachname", phoneSeller: "Telefon", department: "Abteilung",
    createSeller: "Verkaufer Erstellen und E-Mail Senden", noSellers: "Keine Verkaufer registriert",
    clickToAdd: "Klicken Sie \"Neuer Verkaufer\" um ein Teammitglied hinzuzufugen.",
    sellerCreated: "Verkaufer erstellt! Aktivierungs-E-Mail gesendet.", sellerCreateError: "Fehler beim Erstellen des Verkaufers",
    activation: "Aktivierung", active: "Aktiv", pending: "Ausstehend", deactivated: "Konto deaktiviert",
    sellerActivated: "Verkaufer aktiviert", sellerDeactivated: "Verkaufer deaktiviert",
    activationResent: "Aktivierungs-E-Mail erneut gesendet!", deleteSeller: "Verkaufer loschen", deleteConfirm: "Diese Aktion ist unwiderruflich.", sellerDeleted: "Verkaufer geloscht",
    newBackOffice: "Neues Back-Office", addBackOffice: "Back-Office Hinzufugen",
    createBackOffice: "Back-Office Erstellen und E-Mail Senden",
    backOfficeEmailInfo: "Der Back-Office-Benutzer erhalt eine E-Mail mit einem Link zur Passworterstellung. Back-Office-Benutzer konnen Kunden im Namen der Verkaufer anlegen und alle Vertrage uberwachen, erscheinen aber nicht im \"Zugeordneter Verkaufer\"-Dropdown und sehen keine Leistungsstatistiken.",
    backOfficeCreated: "Back-Office-Benutzer erstellt! Aktivierungs-E-Mail gesendet.",
    noBackOffice: "Keine Back-Office-Benutzer registriert",
    clickToAddBackOffice: "Klicken Sie \"Neues Back-Office\" um Verwaltungspersonal hinzuzufugen.",
    sellersReport: "Verkauferbericht", globalTarget: "Globales Monatsziel", globalTargetDesc: "Standard-Ziel fur alle Verkaufer (individuell uberschreibbar)",
    clientsMonth: "Kunden/Monat", target: "Ziel", monthProgress: "Monatsfortschritt", total: "Gesamt",
    performanceBySeller: "Leistung pro Verkaufer", noTarget: "Kein Ziel",
    targetUpdated: "Globales Ziel aktualisiert", customTarget: "Individuelles Ziel", targetRemoved: "Ziel entfernt (nutzt globales)",
    directCustomers: "Direkte Kunden", sellerCount: "Verkaufer",
    monthlyLeaderboard: "Monatliche Rangliste", noSellersReport: "Keine Verkaufer fur Berichterstellung registriert.",
    loadingReport: "Bericht wird geladen...", clickRefresh: "Klicken Sie \"Aktualisieren\" um den Bericht zu laden.",
    notifications: "Benachrichtigungen", markAllRead: "Alle als gelesen markieren", noNotifications: "Keine Benachrichtigungen",
    loginError: "Anmeldefehler", saveError: "Speicherfehler", sendError: "Sendefehler", toggleError: "Umschaltfehler", deleteError: "Loschfehler",
    // ─── auto-translated 2026-06-23 (UI fallback rescue) ───
    enterValidNumber: "Geben Sie eine gueltige Nummer ein",
    vinAlreadyEnrolledTitle: "VIN bereits registriert",
    vinAlreadyEnrolledBody: "Die VIN {vin} ist bereits im System registriert. Ein Fahrzeug kann nicht zwei verschiedenen Kunden zugeordnet werden.",
    existingCustomerLabel: "Bestehender Kunde",
    createdOnLabel: "Erstellt am",
    contractStatusLabel: "Vertrag",
    signedLabel: "Unterschrieben",
    pendingSignatureLabel: "Wartet auf Unterschrift",
    vinDupeOtherDealer: "Das Fahrzeug ist bei einem anderen Haendler registriert. Kontaktieren Sie den LoJack-Support, wenn Sie glauben, dass es sich um einen Fehler handelt.",
    changeVinBtn: "VIN aendern",
    openExistingCustomerBtn: "Kundenkarte oeffnen",
    walletQrTitle: "Wallet-Link  QR-Code bereit zum Anzeigen",
    walletQrSmsModeBody: "Der Kunde in diesem Land erhaelt die Karte per SMS. Zeigen Sie diesem QR-Code dem Kunden, um das Wallet sofort auf seinem Telefon zu oeffnen  ohne auf die Nachricht zu warten.",
    walletQrBothModeBody: "E-Mail und SMS gesendet. Wenn der Kunde vor Ihnen steht, kann er diesen QR-Code scannen, um die Karte sofort zu oeffnen.",
    walletQrShortLinkLabel: "Kurz-Link (fuer WhatsApp / Chat)",
    walletQrCopied: "Link kopiert",
    walletQrCopyBtn: "Kopieren",
    walletQrSmsRecipient: "SMS gesendet an",
    walletQrEmailRecipient: "E-Mail gesendet an",
    walletQrDoneBtn: "Schliessen",
    cannotDeleteContractSigned: "Loeschen nicht moeglich: Vertrag bereits unterschrieben",
    confirmDeleteCustomer: "Kunde {name} ({email}) loeschen?",
    customerDeletedSuccess: "Kunde geloescht",
    customerDeleteError: "Fehler beim Loeschen des Kunden",
    contractNotSignedYet: "Vertrag vom Kunden noch nicht unterschrieben",
    signedPdfDownloaded: "Unterschriebenes PDF heruntergeladen",
    signedPdfDownloadError: "Fehler beim Download des unterschriebenen PDF",
    viewSignedReadonly: "Daten anzeigen (unterschrieben, schreibgeschuetzt)",
    editCustomer: "Kunde bearbeiten",
    downloadSignedPdf: "Unterschriebenen Vertrag herunterladen (PDF)",
    deleteCustomerOnlyUnsigned: "Kunde loeschen (nur wenn nicht unterschrieben)",
    vinApplied: "VIN erkannt",
    phoneCountryMismatchTitle: "Nummer aus anderem Land erkannt",
    phoneCountryMismatchBody: "Die Telefonvorwahl deutet auf einen Kunden aus {detected} hin, aber das Kundenland ist aktuell {current}. Moechten Sie es aktualisieren?",
    phoneCountrySwitchedTo: "Kundenland aktualisiert:",
    phoneCountrySwitchTo: "Land auf {detected} setzen",
    vatCountryMismatchTitle: "USt-IdNr. aus anderem Land erkannt",
    vatCountryMismatchBody: "Das Praefix der USt-IdNr. deutet auf einen Kunden aus {detected} hin, aber das Kundenland ist aktuell {current}. Moechten Sie es aktualisieren?",
    vatCountrySwitchedTo: "Kundenland aktualisiert:",
    vatCountrySwitchTo: "Land auf {detected} setzen",
    vehicleOriginLabel: "Fahrzeug",
    vinAutoApplied: "Fahrzeug erkannt  automatisch ausgefuellt",
    vinEditable: "Die Felder Marke und Modell koennen dennoch bearbeitet werden.",
    vrnOptional: "Optionales Feld",
    sellerCreditedLabel: "Zugeordneter Verkaeufer",
    sellerCreditedPlaceholder: "Verkaeufer auswaehlen...",
    sellerCreditedManagerSuffix: "Inhaber",
    sellerCreditedHintNoSellers: "Sie haben noch keine Verkaeufer hinzugefuegt. Sie koennen diesen Kunden sich selbst zuordnen oder einen neuen im Tab \"Verkaeufer\" erstellen.",
    deactivateAction: "Deaktivieren",
    activateAction: "Aktivieren",
    salesTeamPlaceholder: "z.B. Vertrieb Nord",
    resendActivationEmail: "Aktivierungs-E-Mail erneut senden",
    deleteAction: "Loeschen",
    manual: "Betriebshandbuch",
    mismatchSourceVat: "aus USt-IdNr.",
    mismatchSourcePhone: "aus Telefon",
    mismatchCorrectionReasonDefault: "Korrigiert vom Mismatch-Widget (Haendler)",
    mismatchCountryUpdated: "Land aktualisiert:",
    mismatchCorrectionFailed: "Fehler bei Korrektur",
    mismatchCleanTitle: "Laender-Datenqualitaet:  Ausgezeichnete Arbeit",
    mismatchCleanBody: "Alle {n} Kunden der letzten 30 Tage haben ein konsistentes Land mit USt-IdNr./Telefon.",
    mismatchTitle: "Kunden mit zu ueberpruefendem Land",
    mismatchBodyIntro: "In den letzten 30 Tagen haben Sie",
    mismatchBodyMiddle: "Kunden erstellt, davon haben",
    mismatchBodyEnd: "ein anderes Land als das von der USt-IdNr. oder Telefonvorwahl vorgeschlagene. Mit einem Klick korrigieren.",
    mismatchCurrent: "Aktuell:",
    mismatchFixBtn: "Korrigieren",
    mismatchConfirmQuestion: "Landaenderung bestaetigen auf",
    mismatchReasonPlaceholder: "Korrekturgrund (optional)",
    mismatchSaving: "Speichern...",
    mismatchConfirmFix: "Korrektur bestaetigen",
    mismatchCancel: "Abbrechen",
    language: "Sprache", poweredBy: "Powered by TelcaVoIP AI Engine",
  },
  NL: {
    portalTitle: "Dealer Portaal", loginSubtitle: "Log in om uw klanten te beheren", email: "E-mail", password: "Wachtwoord", login: "Inloggen", forgotPassword: "Wachtwoord vergeten?",
    dealer: "DEALER", seller: "VERKOPER",
    dashboard: "Dashboard", newCustomer: "Nieuwe Klant", myCustomers: "Mijn Klanten", sellers: "Verkopers", backOffice: "Back-Office", report: "Rapport", manuals: "Handleidingen", security: "Beveiliging",
    // Customer-list scope (Fabrizio CR 26/02/2026)
    scopeMineLabel: "Alleen de mijne", scopeAllLabel: "Alle van de dealer", assignedTo: "Toegewezen aan", assignedToManager: "Klant van de manager",
    totalCustomers: "Totaal Klanten", emailsSent: "E-mails Verzonden", termsAccepted: "Voorwaarden Geaccepteerd", contractsSigned: "Contracten Getekend", cardsCreated: "Kaarten Gemaakt", last30days: "Laatste 30 dagen",
    startAdding: "Begin met het toevoegen van een nieuwe klant",
    monthlyTarget: "Maanddoel", targetReached: "Doel bereikt! Uitstekend!", remainingClients: "klanten om het doel te bereiken",
    leaderboard: "Ranglijst", youAreAt: "U staat op", place: "plaats", you: "U", clients: "klanten", contracts: "contracten",
    weeklyDigest: "Wekelijks Overzicht", digestDescription: "Ontvang elke maandag om 8:00 uur een samenvatting per e-mail", sendPreview: "Voorbeeld Verzenden", sending: "Verzenden...",
    digestEnabled: "Wekelijks overzicht geactiveerd", digestDisabled: "Wekelijks overzicht gedeactiveerd", digestSent: "Voorbeeld verzonden naar uw e-mail!",
    phone: "Mobiel", vehicleBrand: "Voertuigmerk", vehicleModel: "Voertuigmodel", vin: "VIN (Chassis)", vrn: "Kenteken", country: "Land", serviceType: "LJ Service Gekocht",
    verifyAndCreate: "Controleer en Maak Klant", creating: "Aanmaken...",
    confirmTitle: "Klantgegevens Bevestigen", confirmSubtitle: "Controleer de gegevens voordat u doorgaat:", brand: "Merk", model: "Model", service: "Service",
    edit: "Bewerken", confirmAndSend: "Bevestigen en Verzenden",
    customerCreated: "Klant aangemaakt! Welkomst-e-mail verzonden.", createError: "Fout bij aanmaken", vinAlreadyEnrolled: "VIN al geregistreerd in het systeem",
    refresh: "Vernieuwen", noCustomers: "Geen klanten toegevoegd", signed: "Getekend", card: "Kaart",
    newSeller: "Nieuwe Verkoper", addSeller: "Verkoper Toevoegen", close: "Sluiten",
    sellerEmailInfo: "De verkoper ontvangt een e-mail met een link om een wachtwoord aan te maken.",
    firstName: "Voornaam", lastName: "Achternaam", phoneSeller: "Telefoon", department: "Afdeling",
    createSeller: "Verkoper Aanmaken en E-mail Verzenden", noSellers: "Geen verkopers geregistreerd",
    clickToAdd: "Klik \"Nieuwe Verkoper\" om een teamlid toe te voegen.",
    sellerCreated: "Verkoper aangemaakt! Activatie-e-mail verzonden.", sellerCreateError: "Fout bij aanmaken verkoper",
    activation: "Activatie", active: "Actief", pending: "In afwachting", deactivated: "Account gedeactiveerd",
    sellerActivated: "Verkoper geactiveerd", sellerDeactivated: "Verkoper gedeactiveerd",
    activationResent: "Activatie-e-mail opnieuw verzonden!", deleteSeller: "Verkoper verwijderen", deleteConfirm: "Deze actie is onomkeerbaar.", sellerDeleted: "Verkoper verwijderd",
    newBackOffice: "Nieuwe Back-Office", addBackOffice: "Back-Office Toevoegen",
    createBackOffice: "Back-Office Aanmaken en E-mail Verzenden",
    backOfficeEmailInfo: "De Back-Office-gebruiker ontvangt een e-mail met een link om een wachtwoord aan te maken. Back-Office-gebruikers kunnen klanten invoeren namens verkopers en alle contracten monitoren, maar verschijnen niet in de \"Toegewezen verkoper\"-dropdown en zien geen prestatiestatistieken.",
    backOfficeCreated: "Back-Office-gebruiker aangemaakt! Activatie-e-mail verzonden.",
    noBackOffice: "Geen Back-Office-gebruikers geregistreerd",
    clickToAddBackOffice: "Klik \"Nieuwe Back-Office\" om administratief personeel toe te voegen.",
    sellersReport: "Verkopersrapport", globalTarget: "Globaal Maanddoel", globalTargetDesc: "Standaarddoel voor alle verkopers (individueel overschrijfbaar)",
    clientsMonth: "klanten/maand", target: "Doel", monthProgress: "Maandvoortgang", total: "Totaal",
    performanceBySeller: "Prestatie per Verkoper", noTarget: "Geen doel",
    targetUpdated: "Globaal doel bijgewerkt", customTarget: "Aangepast doel", targetRemoved: "Doel verwijderd (gebruikt globaal)",
    directCustomers: "Directe Klanten", sellerCount: "Verkopers",
    monthlyLeaderboard: "Maandelijkse Ranglijst", noSellersReport: "Geen verkopers geregistreerd voor rapportage.",
    loadingReport: "Rapport laden...", clickRefresh: "Klik \"Vernieuwen\" om het rapport te laden.",
    notifications: "Meldingen", markAllRead: "Alles als gelezen markeren", noNotifications: "Geen meldingen",
    loginError: "Inlogfout", saveError: "Opslagfout", sendError: "Verzendfout", toggleError: "Schakelfout", deleteError: "Verwijderfout",
    // ─── auto-translated 2026-06-23 (UI fallback rescue) ───
    enterValidNumber: "Voer een geldig nummer in",
    vinAlreadyEnrolledTitle: "VIN reeds geregistreerd",
    vinAlreadyEnrolledBody: "Het VIN {vin} is al geregistreerd in het systeem. Een voertuig kan niet aan twee verschillende klanten worden gekoppeld.",
    existingCustomerLabel: "Bestaande klant",
    createdOnLabel: "Aangemaakt op",
    contractStatusLabel: "Contract",
    signedLabel: "Ondertekend",
    pendingSignatureLabel: "Wacht op ondertekening",
    vinDupeOtherDealer: "Het voertuig is geregistreerd bij een andere dealer. Neem contact op met LoJack support als u denkt dat dit een fout is.",
    changeVinBtn: "Wijzig VIN",
    openExistingCustomerBtn: "Open klantfiche",
    walletQrTitle: "Wallet link - QR klaar om te tonen",
    walletQrSmsModeBody: "De klant in dit land ontvangt de card via SMS. Toon deze QR aan de klant om de wallet direct op zijn telefoon te openen - zonder te wachten op het bericht.",
    walletQrBothModeBody: "Email en SMS verzonden. Als de klant voor u staat, kan hij deze QR scannen om de card direct te openen.",
    walletQrShortLinkLabel: "Korte link (voor WhatsApp / chat)",
    walletQrCopied: "Link gekopieerd",
    walletQrCopyBtn: "Kopieer",
    walletQrSmsRecipient: "SMS verzonden naar",
    walletQrEmailRecipient: "Email verzonden naar",
    walletQrDoneBtn: "Sluit",
    cannotDeleteContractSigned: "Kan niet verwijderen: contract al ondertekend",
    confirmDeleteCustomer: "Klant {name} ({email}) verwijderen?",
    customerDeletedSuccess: "Klant verwijderd",
    customerDeleteError: "Fout bij verwijderen klant",
    contractNotSignedYet: "Contract nog niet ondertekend door klant",
    signedPdfDownloaded: "Ondertekende PDF gedownload",
    signedPdfDownloadError: "Fout bij downloaden ondertekende PDF",
    viewSignedReadonly: "Bekijk gegevens (ondertekend, alleen-lezen)",
    editCustomer: "Wijzig klant",
    downloadSignedPdf: "Download ondertekend contract (PDF)",
    deleteCustomerOnlyUnsigned: "Verwijder klant (alleen indien niet ondertekend)",
    vinApplied: "VIN herkend",
    phoneCountryMismatchTitle: "Nummer van ander land gedetecteerd",
    phoneCountryMismatchBody: "Het telefoonnummer wijst op een {detected} klant, maar het land van de klant is momenteel {current}. Wilt u dit bijwerken?",
    phoneCountrySwitchedTo: "Land klant bijgewerkt:",
    phoneCountrySwitchTo: "Stel land in op {detected}",
    vatCountryMismatchTitle: "BTW-nummer van ander land gedetecteerd",
    vatCountryMismatchBody: "Het voorvoegsel van het BTW-nummer wijst op een {detected} klant, maar het land van de klant is momenteel {current}. Wilt u dit bijwerken?",
    vatCountrySwitchedTo: "Land klant bijgewerkt:",
    vatCountrySwitchTo: "Stel land in op {detected}",
    vehicleOriginLabel: "Voertuig",
    vinAutoApplied: "Voertuig herkend - automatisch ingevuld",
    vinEditable: "De velden Merk en Model zijn nog steeds bewerkbaar.",
    vrnOptional: "Optioneel veld",
    sellerCreditedLabel: "Toegewezen verkoper",
    sellerCreditedPlaceholder: "Selecteer verkoper...",
    sellerCreditedManagerSuffix: "Eigenaar",
    sellerCreditedHintNoSellers: "U heeft nog geen verkopers toegevoegd. U kunt deze klant aan uzelf toewijzen of een verkoper aanmaken via het tabblad \"Verkopers\".",
    deactivateAction: "Deactiveer",
    activateAction: "Activeer",
    salesTeamPlaceholder: "bijv. Verkoop Noord",
    resendActivationEmail: "Verzend activatie-email opnieuw",
    deleteAction: "Verwijder",
    manual: "Handleiding",
    mismatchSourceVat: "van BTW-nummer",
    mismatchSourcePhone: "van telefoon",
    mismatchCorrectionReasonDefault: "Gecorrigeerd door Mismatch widget (dealer)",
    mismatchCountryUpdated: "Land bijgewerkt:",
    mismatchCorrectionFailed: "Fout bij correctie",
    mismatchCleanTitle: "Landgegevenskwaliteit:  Uitstekend werk",
    mismatchCleanBody: "Alle {n} klanten van de afgelopen 30 dagen hebben een land dat consistent is met BTW-nummer/telefoon.",
    mismatchTitle: "Klanten met land om te controleren",
    mismatchBodyIntro: "In de afgelopen 30 dagen heeft u",
    mismatchBodyMiddle: "klanten aangemaakt, waarvan",
    mismatchBodyEnd: "een ander land hebben dan voorgesteld door BTW-nummer of telefoonnummer. Corrigeer met een klik.",
    mismatchCurrent: "Huidig:",
    mismatchFixBtn: "Corrigeer",
    mismatchConfirmQuestion: "Bevestig landwijziging naar",
    mismatchReasonPlaceholder: "Reden voor correctie (optioneel)",
    mismatchSaving: "Opslaan...",
    mismatchConfirmFix: "Bevestig correctie",
    mismatchCancel: "Annuleer",
    language: "Taal", poweredBy: "Powered by TelcaVoIP AI Engine",
  },
  PT: {
    portalTitle: "Portal do Distribuidor", loginSubtitle: "Aceda para gerir os seus clientes", email: "Email", password: "Palavra-passe", login: "Entrar", forgotPassword: "Palavra-passe esquecida?",
    dealer: "DISTRIBUIDOR", seller: "VENDEDOR",
    dashboard: "Painel", newCustomer: "Novo Cliente", myCustomers: "Os Meus Clientes", sellers: "Vendedores", backOffice: "Back-Office", report: "Relatorio", manuals: "Manuais", security: "Seguranca",
    // Customer-list scope (Fabrizio CR 26/02/2026)
    scopeMineLabel: "Apenas os meus", scopeAllLabel: "Todos do dealer", assignedTo: "Atribuído a", assignedToManager: "Cliente do manager",
    totalCustomers: "Clientes Totais", emailsSent: "Emails Enviados", termsAccepted: "Termos Aceites", contractsSigned: "Contratos Assinados", cardsCreated: "Cartoes Criados", last30days: "Ultimos 30 dias",
    startAdding: "Comece adicionando um novo cliente",
    monthlyTarget: "Meta Mensal", targetReached: "Meta atingida! Excelente!", remainingClients: "clientes para atingir a meta",
    leaderboard: "Classificacao", youAreAt: "Esta em", place: "lugar", you: "Voce", clients: "clientes", contracts: "contratos",
    weeklyDigest: "Resumo Semanal", digestDescription: "Receba um resumo por email todas as segundas-feiras as 8:00", sendPreview: "Enviar Pre-visualizacao", sending: "Enviando...",
    digestEnabled: "Resumo semanal ativado", digestDisabled: "Resumo semanal desativado", digestSent: "Pre-visualizacao enviada para o seu email!",
    phone: "Telemovel", vehicleBrand: "Marca do Veiculo", vehicleModel: "Modelo do Veiculo", vin: "VIN (Chassis)", vrn: "Matricula", country: "Pais", serviceType: "Servico LJ Adquirido",
    verifyAndCreate: "Verificar e Criar Cliente", creating: "Criando...",
    confirmTitle: "Confirmar Dados do Cliente", confirmSubtitle: "Verifique os dados antes de continuar:", brand: "Marca", model: "Modelo", service: "Servico",
    edit: "Editar", confirmAndSend: "Confirmar e Enviar",
    customerCreated: "Cliente criado! Email de boas-vindas enviado.", createError: "Erro na criacao", vinAlreadyEnrolled: "VIN ja registado no sistema",
    refresh: "Atualizar", noCustomers: "Nenhum cliente adicionado", signed: "Assinado", card: "Cartao",
    newSeller: "Novo Vendedor", addSeller: "Adicionar Vendedor", close: "Fechar",
    sellerEmailInfo: "O vendedor recebera um email com o link para criar a sua palavra-passe.",
    firstName: "Nome", lastName: "Apelido", phoneSeller: "Telefone", department: "Departamento",
    createSeller: "Criar Vendedor e Enviar Email", noSellers: "Nenhum vendedor registado",
    clickToAdd: "Clique \"Novo Vendedor\" para adicionar um membro da equipa.",
    sellerCreated: "Vendedor criado! Email de ativacao enviado.", sellerCreateError: "Erro ao criar vendedor",
    activation: "Ativacao", active: "Ativo", pending: "Pendente", deactivated: "Conta desativada",
    sellerActivated: "Vendedor ativado", sellerDeactivated: "Vendedor desativado",
    activationResent: "Email de ativacao reenviado!", deleteSeller: "Eliminar vendedor", deleteConfirm: "Esta acao e irreversivel.", sellerDeleted: "Vendedor eliminado",
    newBackOffice: "Novo Back-Office", addBackOffice: "Adicionar Back-Office",
    createBackOffice: "Criar Back-Office e Enviar Email",
    backOfficeEmailInfo: "O utilizador Back-Office recebera um email com o link para criar a sua palavra-passe. Os utilizadores Back-Office podem inserir clientes em nome dos vendedores e monitorizar todos os contratos, mas nao aparecem no dropdown \"Vendedor associado\" nem veem estatisticas de desempenho.",
    backOfficeCreated: "Utilizador Back-Office criado! Email de ativacao enviado.",
    noBackOffice: "Nenhum utilizador Back-Office registado",
    clickToAddBackOffice: "Clique \"Novo Back-Office\" para adicionar pessoal administrativo.",
    sellersReport: "Relatorio de Vendedores", globalTarget: "Meta Mensal Global", globalTargetDesc: "Meta padrao para todos os vendedores (substituivel individualmente)",
    clientsMonth: "clientes/mes", target: "Meta", monthProgress: "Progresso do Mes", total: "Total",
    performanceBySeller: "Desempenho por Vendedor", noTarget: "Sem meta",
    targetUpdated: "Meta global atualizada", customTarget: "Meta personalizada", targetRemoved: "Meta removida (usa global)",
    directCustomers: "Clientes Diretos", sellerCount: "Vendedores",
    monthlyLeaderboard: "Classificacao Mensal", noSellersReport: "Nenhum vendedor registado para gerar relatorio.",
    loadingReport: "Carregando relatorio...", clickRefresh: "Clique \"Atualizar\" para carregar o relatorio.",
    notifications: "Notificacoes", markAllRead: "Marcar tudo como lido", noNotifications: "Sem notificacoes",
    loginError: "Erro de acesso", saveError: "Erro ao guardar", sendError: "Erro ao enviar", toggleError: "Erro ao alterar", deleteError: "Erro ao eliminar",
    // ─── auto-translated 2026-06-23 (UI fallback rescue) ───
    enterValidNumber: "Introduza um numero valido",
    vinAlreadyEnrolledTitle: "VIN ja registado",
    vinAlreadyEnrolledBody: "O VIN {vin} ja se encontra registado no sistema. Um veiculo nao pode estar associado a dois clientes diferentes.",
    existingCustomerLabel: "Cliente existente",
    createdOnLabel: "Criado a",
    contractStatusLabel: "Contrato",
    signedLabel: "Assinado",
    pendingSignatureLabel: "Aguarda assinatura",
    vinDupeOtherDealer: "O veiculo esta registado noutro concessionario. Contacte o suporte LoJack se considerar tratar-se de um erro.",
    changeVinBtn: "Alterar VIN",
    openExistingCustomerBtn: "Abrir ficha de cliente",
    walletQrTitle: "Link wallet  QR pronto a apresentar",
    walletQrSmsModeBody: "O cliente neste pais recebe o cartao via SMS. Mostre este QR ao cliente para abrir de imediato a wallet no telemovel  sem aguardar a mensagem.",
    walletQrBothModeBody: "Email e SMS enviados. Se o cliente estiver presente, pode digitalizar este QR para abrir o cartao imediatamente.",
    walletQrShortLinkLabel: "Link curto (para WhatsApp / chat)",
    walletQrCopied: "Link copiado",
    walletQrCopyBtn: "Copiar",
    walletQrSmsRecipient: "SMS enviado para",
    walletQrEmailRecipient: "Email enviado para",
    walletQrDoneBtn: "Fechar",
    cannotDeleteContractSigned: "Impossivel eliminar: contrato ja assinado",
    confirmDeleteCustomer: "Eliminar o cliente {name} ({email})?",
    customerDeletedSuccess: "Cliente eliminado",
    customerDeleteError: "Erro ao eliminar cliente",
    contractNotSignedYet: "Contrato ainda nao assinado pelo cliente",
    signedPdfDownloaded: "PDF assinado descarregado",
    signedPdfDownloadError: "Erro ao descarregar PDF assinado",
    viewSignedReadonly: "Visualizar dados (assinado, apenas leitura)",
    editCustomer: "Editar cliente",
    downloadSignedPdf: "Descarregar contrato assinado (PDF)",
    deleteCustomerOnlyUnsigned: "Eliminar cliente (apenas se nao assinado)",
    vinApplied: "VIN reconhecido",
    phoneCountryMismatchTitle: "Numero de outro pais detetado",
    phoneCountryMismatchBody: "O indicativo telefonico indica um cliente {detected}, mas o pais do cliente e atualmente {current}. Pretende atualizar?",
    phoneCountrySwitchedTo: "Pais do cliente atualizado:",
    phoneCountrySwitchTo: "Definir pais como {detected}",
    vatCountryMismatchTitle: "NIF de outro pais detetado",
    vatCountryMismatchBody: "O prefixo do NIF indica um cliente {detected}, mas o pais do cliente e atualmente {current}. Pretende atualizar?",
    vatCountrySwitchedTo: "Pais do cliente atualizado:",
    vatCountrySwitchTo: "Definir pais como {detected}",
    vehicleOriginLabel: "Veiculo",
    vinAutoApplied: "Veiculo reconhecido  preenchido automaticamente",
    vinEditable: "Os campos Marca e Modelo sao editaveis.",
    vrnOptional: "Campo opcional",
    sellerCreditedLabel: "Vendedor associado",
    sellerCreditedPlaceholder: "Selecione o vendedor...",
    sellerCreditedManagerSuffix: "Titular",
    sellerCreditedHintNoSellers: "Ainda nao adicionou vendedores. Pode atribuir este cliente a si proprio ou criar um no separador \"Vendedores\".",
    deactivateAction: "Desativar",
    activateAction: "Ativar",
    salesTeamPlaceholder: "ex. Vendas Norte",
    resendActivationEmail: "Reenviar email de ativacao",
    deleteAction: "Eliminar",
    manual: "Manual Operativo",
    mismatchSourceVat: "do NIF",
    mismatchSourcePhone: "do telefone",
    mismatchCorrectionReasonDefault: "Corrigido pelo widget Mismatch (concessionario)",
    mismatchCountryUpdated: "Pais atualizado:",
    mismatchCorrectionFailed: "Erro na correcao",
    mismatchCleanTitle: "Qualidade de dados pais:  Otimo trabalho",
    mismatchCleanBody: "Todos os {n} clientes dos ultimos 30 dias tem o pais coerente com NIF/telefone.",
    mismatchTitle: "Clientes com pais a rever",
    mismatchBodyIntro: "Nos ultimos 30 dias criou",
    mismatchBodyMiddle: "clientes, dos quais",
    mismatchBodyEnd: "tem um pais diferente do sugerido pelo NIF ou indicativo telefonico. Corrija com um clique.",
    mismatchCurrent: "Atual:",
    mismatchFixBtn: "Corrigir",
    mismatchConfirmQuestion: "Confirmar mudanca de pais para",
    mismatchReasonPlaceholder: "Motivo da correcao (opcional)",
    mismatchSaving: "A guardar...",
    mismatchConfirmFix: "Confirmar correcao",
    mismatchCancel: "Cancelar",
    language: "Idioma", poweredBy: "Powered by TelcaVoIP AI Engine",
  },
  PL: {
    portalTitle: "Portal Dealera", loginSubtitle: "Zaloguj sie, aby zarzadzac klientami", email: "E-mail", password: "Haslo", login: "Zaloguj", forgotPassword: "Zapomniales hasla?",
    dealer: "DEALER", seller: "SPRZEDAWCA",
    dashboard: "Panel", newCustomer: "Nowy Klient", myCustomers: "Moi Klienci", sellers: "Sprzedawcy", backOffice: "Back-Office", report: "Raport", manuals: "Instrukcje", security: "Bezpieczenstwo",
    // Customer-list scope (Fabrizio CR 26/02/2026)
    scopeMineLabel: "Tylko moi", scopeAllLabel: "Wszyscy dealera", assignedTo: "Przypisany do", assignedToManager: "Klient managera",
    totalCustomers: "Laczna Liczba Klientow", emailsSent: "Wyslane E-maile", termsAccepted: "Zaakceptowane Warunki", contractsSigned: "Podpisane Umowy", cardsCreated: "Utworzone Karty", last30days: "Ostatnie 30 dni",
    startAdding: "Zacznij od dodania nowego klienta",
    monthlyTarget: "Cel Miesieczny", targetReached: "Cel osiagniety! Swietna robota!", remainingClients: "klientow do osiagniecia celu",
    leaderboard: "Ranking", youAreAt: "Jestes na", place: "miejscu", you: "Ty", clients: "klientow", contracts: "umow",
    weeklyDigest: "Podsumowanie Tygodniowe", digestDescription: "Otrzymuj podsumowanie e-mailem w kazdy poniedzialek o 8:00", sendPreview: "Wyslij Podglad", sending: "Wysylanie...",
    digestEnabled: "Podsumowanie tygodniowe wlaczone", digestDisabled: "Podsumowanie tygodniowe wylaczone", digestSent: "Podglad wyslany na Twoj e-mail!",
    phone: "Telefon", vehicleBrand: "Marka Pojazdu", vehicleModel: "Model Pojazdu", vin: "VIN (Nadwozie)", vrn: "Rejestracja", country: "Kraj", serviceType: "Usluga LJ",
    verifyAndCreate: "Zweryfikuj i Utworz Klienta", creating: "Tworzenie...",
    confirmTitle: "Potwierdz Dane Klienta", confirmSubtitle: "Sprawdz dane przed kontynuowaniem:", brand: "Marka", model: "Model", service: "Usluga",
    edit: "Edytuj", confirmAndSend: "Potwierdz i Wyslij",
    customerCreated: "Klient utworzony! E-mail powitalny wyslany.", createError: "Blad tworzenia", vinAlreadyEnrolled: "VIN juz zarejestrowany w systemie",
    vinAlreadyEnrolledTitle: "VIN juz zarejestrowany",
    vinAlreadyEnrolledBody: "VIN {vin} jest juz zarejestrowany w systemie. Pojazd nie moze byc powiazany z dwoma roznymi klientami.",
    existingCustomerLabel: "Istniejacy klient", createdOnLabel: "Utworzono", contractStatusLabel: "Umowa",
    signedLabel: "Podpisana", pendingSignatureLabel: "Oczekuje na podpis",
    vinDupeOtherDealer: "Pojazd jest zarejestrowany w innym salonie. Skontaktuj sie z LoJack jesli uwazasz to za blad.",
    changeVinBtn: "Zmien VIN", openExistingCustomerBtn: "Otworz karte klienta",
    refresh: "Odswiez", noCustomers: "Brak dodanych klientow", signed: "Podpisany", card: "Karta",
    newSeller: "Nowy Sprzedawca", addSeller: "Dodaj Sprzedawce", close: "Zamknij",
    sellerEmailInfo: "Sprzedawca otrzyma e-mail z linkiem do utworzenia hasla.",
    firstName: "Imie", lastName: "Nazwisko", phoneSeller: "Telefon", department: "Dzial",
    createSeller: "Utworz Sprzedawce i Wyslij E-mail", noSellers: "Brak zarejestrowanych sprzedawcow",
    clickToAdd: "Kliknij \"Nowy Sprzedawca\" aby dodac czlonka zespolu.",
    sellerCreated: "Sprzedawca utworzony! E-mail aktywacyjny wyslany.", sellerCreateError: "Blad tworzenia sprzedawcy",
    activation: "Aktywacja", active: "Aktywny", pending: "Oczekujacy", deactivated: "Konto dezaktywowane",
    sellerActivated: "Sprzedawca aktywowany", sellerDeactivated: "Sprzedawca dezaktywowany",
    activationResent: "E-mail aktywacyjny ponownie wyslany!", deleteSeller: "Usun sprzedawce", deleteConfirm: "Ta akcja jest nieodwracalna.", sellerDeleted: "Sprzedawca usuniety",
    newBackOffice: "Nowy Back-Office", addBackOffice: "Dodaj Back-Office",
    createBackOffice: "Utworz Back-Office i Wyslij E-mail",
    backOfficeEmailInfo: "Uzytkownik Back-Office otrzyma e-mail z linkiem do utworzenia hasla. Uzytkownicy Back-Office moga wprowadzac klientow w imieniu sprzedawcow i monitorowac wszystkie umowy, ale nie pojawiaja sie w rozwijanym menu \"Przypisany sprzedawca\" ani nie widza statystyk wydajnosci.",
    backOfficeCreated: "Uzytkownik Back-Office utworzony! E-mail aktywacyjny wyslany.",
    noBackOffice: "Brak zarejestrowanych uzytkownikow Back-Office",
    clickToAddBackOffice: "Kliknij \"Nowy Back-Office\" aby dodac personel administracyjny.",
    sellersReport: "Raport Sprzedawcow", globalTarget: "Globalny Cel Miesieczny", globalTargetDesc: "Domyslny cel dla wszystkich sprzedawcow (mozna nadpisac indywidualnie)",
    clientsMonth: "klientow/miesiac", target: "Cel", monthProgress: "Postep Miesiaca", total: "Lacznie",
    performanceBySeller: "Wydajnosc Sprzedawcy", noTarget: "Brak celu",
    targetUpdated: "Globalny cel zaktualizowany", customTarget: "Cel indywidualny", targetRemoved: "Cel usuniety (uzywa globalnego)",
    directCustomers: "Klienci Bezposredni", sellerCount: "Sprzedawcy",
    monthlyLeaderboard: "Ranking Miesieczny", noSellersReport: "Brak sprzedawcow do wygenerowania raportu.",
    loadingReport: "Ladowanie raportu...", clickRefresh: "Kliknij \"Odswiez\" aby zaladowac raport.",
    notifications: "Powiadomienia", markAllRead: "Oznacz wszystkie jako przeczytane", noNotifications: "Brak powiadomien",
    loginError: "Blad logowania", saveError: "Blad zapisu", sendError: "Blad wysylki", toggleError: "Blad przelaczania", deleteError: "Blad usuwania",
    // ─── auto-translated 2026-06-23 (UI fallback rescue) ───
    enterValidNumber: "Wprowadz prawidlowy numer",
    walletQrTitle: "Link wallet  QR gotowy do pokazania",
    walletQrSmsModeBody: "Klient w tym kraju otrzymuje karte przez SMS. Pokaz ten QR klientowi, aby otworzyc wallet na jego telefonie  bez czekania na wiadomosc.",
    walletQrBothModeBody: "Email i SMS wyslane. Jesli klient jest przy tobie, moze zeskanowac ten QR, aby otworzyc karte natychmiast.",
    walletQrShortLinkLabel: "Krotki link (dla WhatsApp / chat)",
    walletQrCopied: "Link skopiowany",
    walletQrCopyBtn: "Kopiuj",
    walletQrSmsRecipient: "SMS wyslany do",
    walletQrEmailRecipient: "Email wyslany do",
    walletQrDoneBtn: "Zamknij",
    cannotDeleteContractSigned: "Nie mozna usunac: umowa juz podpisana",
    confirmDeleteCustomer: "Usunac klienta {name} ({email})?",
    customerDeletedSuccess: "Klient usuniety",
    customerDeleteError: "Blad usuwania klienta",
    contractNotSignedYet: "Umowa jeszcze nie podpisana przez klienta",
    signedPdfDownloaded: "Podpisany PDF pobrany",
    signedPdfDownloadError: "Blad pobierania podpisanego PDF",
    viewSignedReadonly: "Wyswietl dane (podpisane, tylko odczyt)",
    editCustomer: "Edytuj klienta",
    downloadSignedPdf: "Pobierz podpisana umowe (PDF)",
    deleteCustomerOnlyUnsigned: "Usun klienta (tylko jesli nie podpisano)",
    vinApplied: "VIN rozpoznany",
    phoneCountryMismatchTitle: "Wykryto numer z innego kraju",
    phoneCountryMismatchBody: "Numer kierunkowy wskazuje klienta {detected}, ale kraj klienta jest obecnie {current}. Zaktualizowac?",
    phoneCountrySwitchedTo: "Kraj klienta zaktualizowany:",
    phoneCountrySwitchTo: "Ustaw kraj na {detected}",
    vatCountryMismatchTitle: "Wykryto NIP z innego kraju",
    vatCountryMismatchBody: "Prefiks NIP wskazuje klienta {detected}, ale kraj klienta jest obecnie {current}. Zaktualizowac?",
    vatCountrySwitchedTo: "Kraj klienta zaktualizowany:",
    vatCountrySwitchTo: "Ustaw kraj na {detected}",
    vehicleOriginLabel: "Pojazd",
    vinAutoApplied: "Pojazd rozpoznany  wypelnione automatycznie",
    vinEditable: "Pola Marka i Model sa jednak edytowalne.",
    vrnOptional: "Pole opcjonalne",
    sellerCreditedLabel: "Przypisany sprzedawca",
    sellerCreditedPlaceholder: "Wybierz sprzedawce...",
    sellerCreditedManagerSuffix: "Wlasciciel",
    sellerCreditedHintNoSellers: "Nie dodales jeszcze sprzedawcow. Mozesz przypisac tego klienta do siebie lub utworzyc sprzedawce w zakladce \"Sprzedawcy\".",
    deactivateAction: "Dezaktywuj",
    activateAction: "Aktywuj",
    salesTeamPlaceholder: "np. Sprzedaz Polnoc",
    resendActivationEmail: "Wyslij ponownie email aktywacyjny",
    deleteAction: "Usun",
    manual: "Podrecznik Operacyjny",
    mismatchSourceVat: "z NIP",
    mismatchSourcePhone: "z telefonu",
    mismatchCorrectionReasonDefault: "Poprawione przez widget Mismatch (dealer)",
    mismatchCountryUpdated: "Kraj zaktualizowany:",
    mismatchCorrectionFailed: "Blad korekty",
    mismatchCleanTitle: "Jakosc danych kraju:  Swietna robota",
    mismatchCleanBody: "Wszyscy {n} klienci z ostatnich 30 dni maja kraj zgodny z NIP/telefonem.",
    mismatchTitle: "Klienci z krajem do sprawdzenia",
    mismatchBodyIntro: "W ciagu ostatnich 30 dni utworzyles",
    mismatchBodyMiddle: "klientow, z ktorych",
    mismatchBodyEnd: "ma inny kraj niz sugerowany przez NIP lub numer kierunkowy. Popraw jednym kliknieciem.",
    mismatchCurrent: "Aktualny:",
    mismatchFixBtn: "Popraw",
    mismatchConfirmQuestion: "Potwierdz zmiane kraju na",
    mismatchReasonPlaceholder: "Powod korekty (opcjonalnie)",
    mismatchSaving: "Zapisywanie...",
    mismatchConfirmFix: "Potwierdz poprawke",
    mismatchCancel: "Anuluj",
    language: "Jezyk", poweredBy: "Powered by TelcaVoIP AI Engine",
  },
  SE: {
    portalTitle: "Aterforsaljarportal", loginSubtitle: "Logga in for att hantera dina kunder", email: "E-post", password: "Losenord", login: "Logga in", forgotPassword: "Glomt losenord?",
    dealer: "ATERFORSALJARE", seller: "SALJARE",
    dashboard: "Oversikt", newCustomer: "Ny Kund", myCustomers: "Mina Kunder", sellers: "Saljare", backOffice: "Back-Office", report: "Rapport", manuals: "Manualer", security: "Sakerhet",
    // Customer-list scope (Fabrizio CR 26/02/2026)
    scopeMineLabel: "Endast mina", scopeAllLabel: "Alla för återförsäljaren", assignedTo: "Tilldelad till", assignedToManager: "Manager-kund",
    totalCustomers: "Totalt Kunder", emailsSent: "E-post Skickade", termsAccepted: "Villkor Accepterade", contractsSigned: "Avtal Undertecknade", cardsCreated: "Kort Skapade", last30days: "Senaste 30 dagarna",
    startAdding: "Borja med att lagga till en ny kund",
    monthlyTarget: "Manadsmal", targetReached: "Mal uppnatt! Bra jobbat!", remainingClients: "kunder kvar till malet",
    leaderboard: "Topplista", youAreAt: "Du ar pa", place: "plats", you: "Du", clients: "kunder", contracts: "avtal",
    weeklyDigest: "Veckosammanfattning", digestDescription: "Fa en sammanfattning via e-post varje mandag kl 8:00", sendPreview: "Skicka Forhandsvisning", sending: "Skickar...",
    digestEnabled: "Veckosammanfattning aktiverad", digestDisabled: "Veckosammanfattning inaktiverad", digestSent: "Forhandsvisning skickad till din e-post!",
    phone: "Mobil", vehicleBrand: "Fordonsmarke", vehicleModel: "Fordonsmodell", vin: "VIN (Chassi)", vrn: "Registreringsnummer", country: "Land", serviceType: "LJ-tjanst",
    verifyAndCreate: "Verifiera och Skapa Kund", creating: "Skapar...",
    confirmTitle: "Bekrafta Kunduppgifter", confirmSubtitle: "Verifiera uppgifterna innan du fortsatter:", brand: "Marke", model: "Modell", service: "Tjanst",
    edit: "Redigera", confirmAndSend: "Bekrafta och Skicka",
    customerCreated: "Kund skapad! Valkomst-e-post skickad.", createError: "Skapningsfel", vinAlreadyEnrolled: "VIN redan registrerat i systemet",
    refresh: "Uppdatera", noCustomers: "Inga kunder tillagda", signed: "Undertecknad", card: "Kort",
    newSeller: "Ny Saljare", addSeller: "Lagg till Saljare", close: "Stang",
    sellerEmailInfo: "Saljaren far ett e-postmeddelande med en lank for att skapa sitt losenord.",
    firstName: "Fornamn", lastName: "Efternamn", phoneSeller: "Telefon", department: "Avdelning",
    createSeller: "Skapa Saljare och Skicka E-post", noSellers: "Inga saljare registrerade",
    clickToAdd: "Klicka \"Ny Saljare\" for att lagga till en teammedlem.",
    sellerCreated: "Saljare skapad! Aktiverings-e-post skickad.", sellerCreateError: "Fel vid skapande av saljare",
    activation: "Aktivering", active: "Aktiv", pending: "Vantar", deactivated: "Konto inaktiverat",
    sellerActivated: "Saljare aktiverad", sellerDeactivated: "Saljare inaktiverad",
    activationResent: "Aktiverings-e-post skickad igen!", deleteSeller: "Ta bort saljare", deleteConfirm: "Denna atgard ar oaterkallig.", sellerDeleted: "Saljare borttagen",
    newBackOffice: "Ny Back-Office", addBackOffice: "Lagg till Back-Office",
    createBackOffice: "Skapa Back-Office och Skicka E-post",
    backOfficeEmailInfo: "Back-Office-anvandaren far ett e-postmeddelande med en lank for att skapa sitt losenord. Back-Office-anvandare kan registrera kunder for saljarnas rakning och overvaka alla avtal, men visas inte i \"Tilldelad saljare\"-listan och ser inte prestandastatistik.",
    backOfficeCreated: "Back-Office-anvandare skapad! Aktiverings-e-post skickad.",
    noBackOffice: "Inga Back-Office-anvandare registrerade",
    clickToAddBackOffice: "Klicka \"Ny Back-Office\" for att lagga till administrativ personal.",
    sellersReport: "Saljarrapport", globalTarget: "Globalt Manadsmal", globalTargetDesc: "Standardmal for alla saljare (kan overskridas individuellt)",
    clientsMonth: "kunder/manad", target: "Mal", monthProgress: "Manadsframsteg", total: "Totalt",
    performanceBySeller: "Prestation per Saljare", noTarget: "Inget mal",
    targetUpdated: "Globalt mal uppdaterat", customTarget: "Anpassat mal", targetRemoved: "Mal borttaget (anvander globalt)",
    directCustomers: "Direkta Kunder", sellerCount: "Saljare",
    monthlyLeaderboard: "Manatlig Topplista", noSellersReport: "Inga saljare registrerade for rapportgenerering.",
    loadingReport: "Laddar rapport...", clickRefresh: "Klicka \"Uppdatera\" for att ladda rapporten.",
    notifications: "Aviseringar", markAllRead: "Markera alla som lasta", noNotifications: "Inga aviseringar",
    loginError: "Inloggningsfel", saveError: "Sparfel", sendError: "Sandningsfel", toggleError: "Vaxlingsfel", deleteError: "Borttagningsfel",
    // ─── auto-translated 2026-06-23 (UI fallback rescue) ───
    enterValidNumber: "Ange ett giltigt nummer",
    vinAlreadyEnrolledTitle: "VIN redan registrerat",
    vinAlreadyEnrolledBody: "VIN {vin} ar redan registrerat i systemet. Ett fordon kan inte kopplas till tva olika kunder.",
    existingCustomerLabel: "Befintlig kund",
    createdOnLabel: "Skapad",
    contractStatusLabel: "Kontrakt",
    signedLabel: "Signerat",
    pendingSignatureLabel: "Vantar pa signatur",
    vinDupeOtherDealer: "Fordonet ar registrerat hos en annan aterforssaljare. Kontakta LoJack support om du tror att detta ar ett fel.",
    changeVinBtn: "Andra VIN",
    openExistingCustomerBtn: "Oppna kundkort",
    walletQrTitle: "Wallet-lank  QR klar att visas",
    walletQrSmsModeBody: "Kunden i detta land tar emot kortet via SMS. Visa denna QR for kunden for att oppna wallet direkt pa telefonen  utan att vanta pa meddelandet.",
    walletQrBothModeBody: "E-post och SMS skickade. Om kunden ar framfor dig kan den skanna denna QR for att oppna kortet omedelbart.",
    walletQrShortLinkLabel: "Kort lank (for WhatsApp / chatt)",
    walletQrCopied: "Lank kopierad",
    walletQrCopyBtn: "Kopiera",
    walletQrSmsRecipient: "SMS skickat till",
    walletQrEmailRecipient: "E-post skickat till",
    walletQrDoneBtn: "Stang",
    cannotDeleteContractSigned: "Kan inte raderas: kontrakt redan signerat",
    confirmDeleteCustomer: "Radera kunden {name} ({email})?",
    customerDeletedSuccess: "Kund raderad",
    customerDeleteError: "Fel vid radering av kund",
    contractNotSignedYet: "Kontraktet inte signerat av kunden annu",
    signedPdfDownloaded: "Signerad PDF nedladdad",
    signedPdfDownloadError: "Fel vid nedladdning av signerad PDF",
    viewSignedReadonly: "Visa data (signerat, skrivskyddat)",
    editCustomer: "Redigera kund",
    downloadSignedPdf: "Ladda ner signerat kontrakt (PDF)",
    deleteCustomerOnlyUnsigned: "Radera kund (endast om ej signerat)",
    vinApplied: "VIN igenkant",
    phoneCountryMismatchTitle: "Nummer fran annat land upptackt",
    phoneCountryMismatchBody: "Telefonnumret indikerar en {detected}-kund, men kundens land ar for narvarande {current}. Vill du uppdatera?",
    phoneCountrySwitchedTo: "Kundland uppdaterat:",
    phoneCountrySwitchTo: "Stall in land pa {detected}",
    vatCountryMismatchTitle: "Momsnummer fran annat land upptackt",
    vatCountryMismatchBody: "Momsnumrets prefix indikerar en {detected}-kund, men kundens land ar for narvarande {current}. Vill du uppdatera?",
    vatCountrySwitchedTo: "Kundland uppdaterat:",
    vatCountrySwitchTo: "Stall in land pa {detected}",
    vehicleOriginLabel: "Fordon",
    vinAutoApplied: "Fordon igenkant  ifyllt automatiskt",
    vinEditable: "Falten Marke och Modell kan fortfarande andras.",
    vrnOptional: "Valfritt falt",
    sellerCreditedLabel: "Kopplad saljare",
    sellerCreditedPlaceholder: "Valj saljare...",
    sellerCreditedManagerSuffix: "Agare",
    sellerCreditedHintNoSellers: "Du har inte lagt till nagra saljare annu. Du kan tilldela denna kund till dig sjalv eller skapa en fran fliken \"Saljare\".",
    deactivateAction: "Inaktivera",
    activateAction: "Aktivera",
    salesTeamPlaceholder: "t.ex. Forsaljning Nord",
    resendActivationEmail: "Skicka aktiveringsmail igen",
    deleteAction: "Radera",
    manual: "Anvandardbok",
    mismatchSourceVat: "fran momsnummer",
    mismatchSourcePhone: "fran telefon",
    mismatchCorrectionReasonDefault: "Korrigerat fran Mismatch-widget (aterforssaljare)",
    mismatchCountryUpdated: "Land uppdaterat:",
    mismatchCorrectionFailed: "Korrigeringsfel",
    mismatchCleanTitle: "Datakvalitet land:  Utmarkt arbete",
    mismatchCleanBody: "Alla {n} kunder fran de senaste 30 dagarna har land som stammar med momsnummer/telefon.",
    mismatchTitle: "Kunder med land att granska",
    mismatchBodyIntro: "Under de senaste 30 dagarna har du skapat",
    mismatchBodyMiddle: "kunder, varav",
    mismatchBodyEnd: "har ett annat land an det som foreslas av momsnummer eller riktnummer. Korrigera med ett klick.",
    mismatchCurrent: "Nuvarande:",
    mismatchFixBtn: "Korrigera",
    mismatchConfirmQuestion: "Bekrafta landbyte till",
    mismatchReasonPlaceholder: "Anledning till korrigering (valfritt)",
    mismatchSaving: "Sparar...",
    mismatchConfirmFix: "Bekrafta korrigering",
    mismatchCancel: "Avbryt",
    language: "Sprak", poweredBy: "Powered by TelcaVoIP AI Engine",
  },
  NO: {
    portalTitle: "Forhandlerportal", loginSubtitle: "Logg inn for a administrere kundene dine", email: "E-post", password: "Passord", login: "Logg inn", forgotPassword: "Glemt passord?",
    dealer: "FORHANDLER", seller: "SELGER",
    dashboard: "Oversikt", newCustomer: "Ny Kunde", myCustomers: "Mine Kunder", sellers: "Selgere", backOffice: "Back-Office", report: "Rapport", manuals: "Manualer", security: "Sikkerhet",
    // Customer-list scope (Fabrizio CR 26/02/2026)
    scopeMineLabel: "Bare mine", scopeAllLabel: "Alle hos forhandler", assignedTo: "Tildelt til", assignedToManager: "Manager-kunde",
    totalCustomers: "Totalt Kunder", emailsSent: "E-poster Sendt", termsAccepted: "Vilkar Godtatt", contractsSigned: "Kontrakter Signert", cardsCreated: "Kort Opprettet", last30days: "Siste 30 dager",
    startAdding: "Begynn med a legge til en ny kunde", monthlyTarget: "Manedlig Mal", targetReached: "Mal nadd! Bra jobbet!", remainingClients: "kunder igjen til malet",
    leaderboard: "Toppliste", youAreAt: "Du er pa", place: "plass", you: "Du", clients: "kunder", contracts: "kontrakter",
    weeklyDigest: "Ukentlig Sammendrag", digestDescription: "Motta et sammendrag pa e-post hver mandag kl 8:00", sendPreview: "Send Forhandsvisning", sending: "Sender...",
    digestEnabled: "Ukentlig sammendrag aktivert", digestDisabled: "Ukentlig sammendrag deaktivert", digestSent: "Forhandsvisning sendt til din e-post!",
    phone: "Mobil", vehicleBrand: "Kjoretoymerke", vehicleModel: "Kjoretoymodell", vin: "VIN (Chassis)", vrn: "Registreringsnummer", country: "Land", serviceType: "LJ-tjeneste",
    verifyAndCreate: "Verifiser og Opprett Kunde", creating: "Oppretter...",
    confirmTitle: "Bekreft Kundedata", confirmSubtitle: "Kontroller dataene for du fortsetter:", brand: "Merke", model: "Modell", service: "Tjeneste",
    edit: "Rediger", confirmAndSend: "Bekreft og Send",
    customerCreated: "Kunde opprettet! Velkomst-e-post sendt.", createError: "Opprettelsesfeil", vinAlreadyEnrolled: "VIN allerede registrert i systemet",
    refresh: "Oppdater", noCustomers: "Ingen kunder lagt til", signed: "Signert", card: "Kort",
    newSeller: "Ny Selger", addSeller: "Legg til Selger", close: "Lukk",
    sellerEmailInfo: "Selgeren vil motta en e-post med en lenke for a opprette passord.",
    firstName: "Fornavn", lastName: "Etternavn", phoneSeller: "Telefon", department: "Avdeling",
    createSeller: "Opprett Selger og Send E-post", noSellers: "Ingen selgere registrert",
    clickToAdd: "Klikk \"Ny Selger\" for a legge til et teammedlem.",
    sellerCreated: "Selger opprettet! Aktiverings-e-post sendt.", sellerCreateError: "Feil ved opprettelse av selger",
    activation: "Aktivering", active: "Aktiv", pending: "Venter", deactivated: "Konto deaktivert",
    sellerActivated: "Selger aktivert", sellerDeactivated: "Selger deaktivert",
    activationResent: "Aktiverings-e-post sendt pa nytt!", deleteSeller: "Slett selger", deleteConfirm: "Denne handlingen er irreversibel.", sellerDeleted: "Selger slettet",
    newBackOffice: "Ny Back-Office", addBackOffice: "Legg til Back-Office",
    createBackOffice: "Opprett Back-Office og Send E-post",
    backOfficeEmailInfo: "Back-Office-brukeren mottar en e-post med en lenke for a opprette passord. Back-Office-brukere kan registrere kunder pa vegne av selgere og overvake alle kontrakter, men vises ikke i \"Tildelt selger\"-listen og ser ikke ytelsesstatistikk.",
    backOfficeCreated: "Back-Office-bruker opprettet! Aktiverings-e-post sendt.",
    noBackOffice: "Ingen Back-Office-brukere registrert",
    clickToAddBackOffice: "Klikk \"Ny Back-Office\" for a legge til administrativt personell.",
    sellersReport: "Selgerrapport", globalTarget: "Globalt Manedlig Mal", globalTargetDesc: "Standardmal for alle selgere (kan overstyres individuelt)",
    clientsMonth: "kunder/maned", target: "Mal", monthProgress: "Manedsfremdrift", total: "Totalt",
    performanceBySeller: "Ytelse per Selger", noTarget: "Ingen mal",
    targetUpdated: "Globalt mal oppdatert", customTarget: "Tilpasset mal", targetRemoved: "Mal fjernet (bruker globalt)",
    directCustomers: "Direkte Kunder", sellerCount: "Selgere",
    monthlyLeaderboard: "Manedlig Toppliste", noSellersReport: "Ingen selgere registrert for rapportgenerering.",
    loadingReport: "Laster rapport...", clickRefresh: "Klikk \"Oppdater\" for a laste rapporten.",
    notifications: "Varsler", markAllRead: "Merk alle som lest", noNotifications: "Ingen varsler",
    loginError: "Innloggingsfeil", saveError: "Lagringsfeil", sendError: "Sendefeil", toggleError: "Byttefeil", deleteError: "Slettefeil",
    // ─── auto-translated 2026-06-23 (UI fallback rescue) ───
    enterValidNumber: "Angi et gyldig nummer",
    vinAlreadyEnrolledTitle: "VIN allerede registrert",
    vinAlreadyEnrolledBody: "VIN {vin} er allerede registrert i systemet. Et kjoretoy kan ikke knyttes til to forskjellige kunder.",
    existingCustomerLabel: "Eksisterende kunde",
    createdOnLabel: "Opprettet",
    contractStatusLabel: "Kontrakt",
    signedLabel: "Signert",
    pendingSignatureLabel: "Venter pa signatur",
    vinDupeOtherDealer: "Kjoretoy er registrert hos en annen forhandler. Kontakt LoJack support hvis du mener dette er en feil.",
    changeVinBtn: "Endre VIN",
    openExistingCustomerBtn: "Apne kundefil",
    walletQrTitle: "Wallet-lenke  QR klar til visning",
    walletQrSmsModeBody: "Kunden i dette landet mottar kortet via SMS. Vis denne QR-koden til kunden for a apne wallet pa telefonen umiddelbart  uten a vente pa meldingen.",
    walletQrBothModeBody: "E-post og SMS sendt. Hvis kunden er til stede, kan QR-koden skannes for a apne kortet umiddelbart.",
    walletQrShortLinkLabel: "Kort lenke (for WhatsApp / chat)",
    walletQrCopied: "Lenke kopiert",
    walletQrCopyBtn: "Kopier",
    walletQrSmsRecipient: "SMS sendt til",
    walletQrEmailRecipient: "E-post sendt til",
    walletQrDoneBtn: "Lukk",
    cannotDeleteContractSigned: "Kan ikke slette: kontrakt allerede signert",
    confirmDeleteCustomer: "Slette kunden {name} ({email})?",
    customerDeletedSuccess: "Kunde slettet",
    customerDeleteError: "Feil ved sletting av kunde",
    contractNotSignedYet: "Kontrakt ikke signert av kunden enna",
    signedPdfDownloaded: "Signert PDF lastet ned",
    signedPdfDownloadError: "Feil ved nedlasting av signert PDF",
    viewSignedReadonly: "Vis data (signert, skrivebeskyttet)",
    editCustomer: "Rediger kunde",
    downloadSignedPdf: "Last ned signert kontrakt (PDF)",
    deleteCustomerOnlyUnsigned: "Slett kunde (kun hvis ikke signert)",
    vinApplied: "VIN gjenkjent",
    phoneCountryMismatchTitle: "Nummer fra annet land oppdaget",
    phoneCountryMismatchBody: "Retningsnummeret indikerer en kunde fra {detected}, men kundens land er for tiden {current}. Vil du oppdatere?",
    phoneCountrySwitchedTo: "Kundeland oppdatert:",
    phoneCountrySwitchTo: "Sett land til {detected}",
    vatCountryMismatchTitle: "Org.nr fra annet land oppdaget",
    vatCountryMismatchBody: "Prefikset pa org.nr indikerer en kunde fra {detected}, men kundens land er for tiden {current}. Vil du oppdatere?",
    vatCountrySwitchedTo: "Kundeland oppdatert:",
    vatCountrySwitchTo: "Sett land til {detected}",
    vehicleOriginLabel: "Kjoretoy",
    vinAutoApplied: "Kjoretoy gjenkjent  fylt ut automatisk",
    vinEditable: "Feltene Merke og Modell kan fortsatt endres.",
    vrnOptional: "Valgfritt felt",
    sellerCreditedLabel: "Tilknyttet selger",
    sellerCreditedPlaceholder: "Velg selger...",
    sellerCreditedManagerSuffix: "Eier",
    sellerCreditedHintNoSellers: "Du har ikke lagt til selgere enna. Du kan tilskrive denne kunden til deg selv eller opprette en fra fanen \"Selgere\".",
    deactivateAction: "Deaktiver",
    activateAction: "Aktiver",
    salesTeamPlaceholder: "f.eks. Salg Nord",
    resendActivationEmail: "Send aktiverings-e-post pa nytt",
    deleteAction: "Slett",
    manual: "Brukermanual",
    mismatchSourceVat: "fra org.nr",
    mismatchSourcePhone: "fra telefon",
    mismatchCorrectionReasonDefault: "Rettet fra Mismatch-widget (forhandler)",
    mismatchCountryUpdated: "Land oppdatert:",
    mismatchCorrectionFailed: "Feil ved korrigering",
    mismatchCleanTitle: "Datakvalitet land:  Flott arbeid",
    mismatchCleanBody: "Alle {n} kunder de siste 30 dagene har land i samsvar med org.nr/telefon.",
    mismatchTitle: "Kunder med land som bor gjennomgas",
    mismatchBodyIntro: "De siste 30 dagene har du opprettet",
    mismatchBodyMiddle: "kunder, hvorav",
    mismatchBodyEnd: "har et land som er forskjellig fra det som er foreslatt av org.nr eller retningsnummer. Korriger med ett klikk.",
    mismatchCurrent: "Gjeldende:",
    mismatchFixBtn: "Korriger",
    mismatchConfirmQuestion: "Bekreft endring av land til",
    mismatchReasonPlaceholder: "Arsak til korrigering (valgfritt)",
    mismatchSaving: "Lagrer...",
    mismatchConfirmFix: "Bekreft korrigering",
    mismatchCancel: "Avbryt",
    language: "Sprak", poweredBy: "Powered by TelcaVoIP AI Engine",
  },
  FI: {
    portalTitle: "Jalleenmyyjaportaali", loginSubtitle: "Kirjaudu hallitaksesi asiakkaitasi", email: "Sahkoposti", password: "Salasana", login: "Kirjaudu", forgotPassword: "Unohditko salasanan?",
    dealer: "JALLEENMYYJA", seller: "MYYJA",
    dashboard: "Yleisnakyyma", newCustomer: "Uusi Asiakas", myCustomers: "Omat Asiakkaat", sellers: "Myyjat", backOffice: "Back-Office", report: "Raportti", manuals: "Kasikirjat", security: "Turvallisuus",
    // Customer-list scope (Fabrizio CR 26/02/2026)
    scopeMineLabel: "Vain omat", scopeAllLabel: "Kaikki jälleenmyyjän", assignedTo: "Vastuuhenkilö", assignedToManager: "Managerin asiakas",
    totalCustomers: "Asiakkaita Yhteensa", emailsSent: "Sahkopostit Lahetetty", termsAccepted: "Ehdot Hyvaksytty", contractsSigned: "Sopimukset Allekirjoitettu", cardsCreated: "Kortit Luotu", last30days: "Viimeiset 30 paivaa",
    startAdding: "Aloita lisaamalla uusi asiakas", monthlyTarget: "Kuukausitavoite", targetReached: "Tavoite saavutettu! Hienoa!", remainingClients: "asiakasta tavoitteeseen",
    leaderboard: "Tulostaulu", youAreAt: "Olet sijalla", place: "", you: "Sina", clients: "asiakasta", contracts: "sopimusta",
    weeklyDigest: "Viikkoyhteenveto", digestDescription: "Saat yhteenvedon sahkopostilla joka maanantai klo 8:00", sendPreview: "Laheta Esikatselu", sending: "Lahetetaan...",
    digestEnabled: "Viikkoyhteenveto aktivoitu", digestDisabled: "Viikkoyhteenveto poistettu kaytosta", digestSent: "Esikatselu lahetetty sahkopostiisi!",
    phone: "Puhelin", vehicleBrand: "Ajoneuvon Merkki", vehicleModel: "Ajoneuvon Malli", vin: "VIN (Alusta)", vrn: "Rekisterinumero", country: "Maa", serviceType: "LJ-palvelu",
    verifyAndCreate: "Tarkista ja Luo Asiakas", creating: "Luodaan...",
    confirmTitle: "Vahvista Asiakastiedot", confirmSubtitle: "Tarkista tiedot ennen jatkamista:", brand: "Merkki", model: "Malli", service: "Palvelu",
    edit: "Muokkaa", confirmAndSend: "Vahvista ja Laheta",
    customerCreated: "Asiakas luotu! Tervetuloa-sahkoposti lahetetty.", createError: "Luontivirhe", vinAlreadyEnrolled: "VIN on jo rekisteroity jarjestelmaan",
    refresh: "Paivita", noCustomers: "Ei lisattyja asiakkaita", signed: "Allekirjoitettu", card: "Kortti",
    newSeller: "Uusi Myyja", addSeller: "Lisaa Myyja", close: "Sulje",
    sellerEmailInfo: "Myyja saa sahkopostin jossa on linkki salasanan luomiseen.",
    firstName: "Etunimi", lastName: "Sukunimi", phoneSeller: "Puhelin", department: "Osasto",
    createSeller: "Luo Myyja ja Laheta Sahkoposti", noSellers: "Ei rekisteroityja myyjia",
    clickToAdd: "Napsauta \"Uusi Myyja\" lisataksesi tiimin jasenen.",
    sellerCreated: "Myyja luotu! Aktivointisahkoposti lahetetty.", sellerCreateError: "Virhe myyjan luonnissa",
    activation: "Aktivointi", active: "Aktiivinen", pending: "Odottaa", deactivated: "Tili poistettu kaytosta",
    sellerActivated: "Myyja aktivoitu", sellerDeactivated: "Myyja poistettu kaytosta",
    activationResent: "Aktivointisahkoposti lahetetty uudelleen!", deleteSeller: "Poista myyja", deleteConfirm: "Tata toimintoa ei voi perua.", sellerDeleted: "Myyja poistettu",
    newBackOffice: "Uusi Back-Office", addBackOffice: "Lisaa Back-Office",
    createBackOffice: "Luo Back-Office ja Laheta Sahkoposti",
    backOfficeEmailInfo: "Back-Office-kayttaja saa sahkopostin jossa on linkki salasanan luomiseen. Back-Office-kayttajat voivat lisata asiakkaita myyjien puolesta ja seurata kaikkia sopimuksia, mutta heita ei nay \"Vastuumyyja\"-pudotusvalikossa eivatka he nae suorituskykytilastoja.",
    backOfficeCreated: "Back-Office-kayttaja luotu! Aktivointisahkoposti lahetetty.",
    noBackOffice: "Ei rekisteroityja Back-Office-kayttajia",
    clickToAddBackOffice: "Napsauta \"Uusi Back-Office\" lisataksesi hallintohenkilostoa.",
    sellersReport: "Myyjien Raportti", globalTarget: "Globaali Kuukausitavoite", globalTargetDesc: "Oletustavoite kaikille myyjille (voidaan korvata erikseen)",
    clientsMonth: "asiakasta/kuukausi", target: "Tavoite", monthProgress: "Kuukauden Edistyminen", total: "Yhteensa",
    performanceBySeller: "Suorituskyky Myyjittain", noTarget: "Ei tavoitetta",
    targetUpdated: "Globaali tavoite paivitetty", customTarget: "Mukautettu tavoite", targetRemoved: "Tavoite poistettu (kayttaa globaalia)",
    directCustomers: "Suorat Asiakkaat", sellerCount: "Myyjat",
    monthlyLeaderboard: "Kuukausittainen Tulostaulu", noSellersReport: "Ei myyjia raportin luomiseen.",
    loadingReport: "Ladataan raporttia...", clickRefresh: "Napsauta \"Paivita\" ladataksesi raportin.",
    notifications: "Ilmoitukset", markAllRead: "Merkitse kaikki luetuiksi", noNotifications: "Ei ilmoituksia",
    loginError: "Kirjautumisvirhe", saveError: "Tallennusvirhe", sendError: "Lahetysvirhe", toggleError: "Vaihtovirhe", deleteError: "Poistovirhe",
    // ─── auto-translated 2026-06-23 (UI fallback rescue) ───
    enterValidNumber: "Syota kelvollinen numero",
    vinAlreadyEnrolledTitle: "VIN jo rekisteroity",
    vinAlreadyEnrolledBody: "VIN {vin} on jo rekisteroity jarjestelmaan. Ajoneuvoa ei voi liittaa kahteen eri asiakkaaseen.",
    existingCustomerLabel: "Olemassa oleva asiakas",
    createdOnLabel: "Luotu",
    contractStatusLabel: "Sopimus",
    signedLabel: "Allekirjoitettu",
    pendingSignatureLabel: "Odottaa allekirjoitusta",
    vinDupeOtherDealer: "Ajoneuvo on rekisteroity toisella jalkimyyjalla. Ota yhteytta LoJack-tukeen, jos epailet virhetta.",
    changeVinBtn: "Muuta VIN",
    openExistingCustomerBtn: "Avaa asiakaskortti",
    walletQrTitle: "Wallet-linkki  QR naytettavaksi",
    walletQrSmsModeBody: "Asiakas tassa maassa vastaanottaa kortin SMS:lla. Nayta tama QR asiakkaalle avataksesi walletin heti puhelimessa  odottamatta viestia.",
    walletQrBothModeBody: "Email ja SMS lahetetty. Jos asiakas on paikalla, han voi skannata taman QR:n avatakseen kortin valittomasti.",
    walletQrShortLinkLabel: "Lyhyt linkki (WhatsApp / chat)",
    walletQrCopied: "Linkki kopioitu",
    walletQrCopyBtn: "Kopioi",
    walletQrSmsRecipient: "SMS lahetetty",
    walletQrEmailRecipient: "Email lahetetty",
    walletQrDoneBtn: "Sulje",
    cannotDeleteContractSigned: "Ei voi poistaa: sopimus jo allekirjoitettu",
    confirmDeleteCustomer: "Poistetaanko asiakas {name} ({email})?",
    customerDeletedSuccess: "Asiakas poistettu",
    customerDeleteError: "Virhe asiakkaan poistossa",
    contractNotSignedYet: "Sopimusta ei ole viela allekirjoitettu",
    signedPdfDownloaded: "Allekirjoitettu PDF ladattu",
    signedPdfDownloadError: "Virhe allekirjoitetun PDF:n latauksessa",
    viewSignedReadonly: "Nayta tiedot (allekirjoitettu, vain luku)",
    editCustomer: "Muokkaa asiakasta",
    downloadSignedPdf: "Lataa allekirjoitettu sopimus (PDF)",
    deleteCustomerOnlyUnsigned: "Poista asiakas (vain jos ei allekirjoitettu)",
    vinApplied: "VIN tunnistettu",
    phoneCountryMismatchTitle: "Toisen maan numero havaittu",
    phoneCountryMismatchBody: "Puhelinkoodi viittaa asiakkaaseen {detected}, mutta asiakkaan maa on tall hetkella {current}. Paivitetaanko?",
    phoneCountrySwitchedTo: "Asiakkaan maa paivitetty:",
    phoneCountrySwitchTo: "Aseta maaksi {detected}",
    vatCountryMismatchTitle: "Toisen maan ALV havaittu",
    vatCountryMismatchBody: "ALV-tunnuksen etuliite viittaa asiakkaaseen {detected}, mutta asiakkaan maa on talla hetkella {current}. Paivitetaanko?",
    vatCountrySwitchedTo: "Asiakkaan maa paivitetty:",
    vatCountrySwitchTo: "Aseta maaksi {detected}",
    vehicleOriginLabel: "Ajoneuvo",
    vinAutoApplied: "Ajoneuvo tunnistettu  taytett automaattisesti",
    vinEditable: "Merkki- ja Malli-kentat ovat silti muokattavissa.",
    vrnOptional: "Valinnainen kentta",
    sellerCreditedLabel: "Liitetty myyja",
    sellerCreditedPlaceholder: "Valitse myyja...",
    sellerCreditedManagerSuffix: "Omistaja",
    sellerCreditedHintNoSellers: "Et ole viela lisannyt myyji. Voit liittaa taman asiakkaan itsellesi tai luoda uuden \"Myyjat\"-valilehdelt.",
    deactivateAction: "Poista kaytosta",
    activateAction: "Aktivoi",
    salesTeamPlaceholder: "esim. Pohjoisen myynti",
    resendActivationEmail: "Lahet aktivointiemail uudelleen",
    deleteAction: "Poista",
    manual: "Kayttajan opas",
    mismatchSourceVat: "ALV:sta",
    mismatchSourcePhone: "puhelimesta",
    mismatchCorrectionReasonDefault: "Korjattu Mismatch-widgetista (jalkimyyj)",
    mismatchCountryUpdated: "Maa paivitetty:",
    mismatchCorrectionFailed: "Virhe korjauksessa",
    mismatchCleanTitle: "Maan tietojen laatu:  Hyvaa tyota",
    mismatchCleanBody: "Kaikilla {n} asiakkaalla viimeisten 30 paivan ajalta maa on yhdenmukainen ALV:n/puhelinnumeron kanssa.",
    mismatchTitle: "Asiakkaat, joiden maa tarkistettava",
    mismatchBodyIntro: "Viimeisten 30 paivan aikana olet luonut",
    mismatchBodyMiddle: "asiakasta, joista",
    mismatchBodyEnd: "maalla on eri maa kuin ALV tai puhelinkoodi ehdottaa. Korjaa yhdella klikkauksella.",
    mismatchCurrent: "Nykyinen:",
    mismatchFixBtn: "Korjaa",
    mismatchConfirmQuestion: "Vahvista maan muutos",
    mismatchReasonPlaceholder: "Korjauksen syy (valinnainen)",
    mismatchSaving: "Tallennetaan...",
    mismatchConfirmFix: "Vahvista korjaus",
    mismatchCancel: "Peruuta",
    language: "Kieli", poweredBy: "Powered by TelcaVoIP AI Engine",
  },
  DK: {
    portalTitle: "Forhandlerportal", loginSubtitle: "Log ind for at administrere dine kunder", email: "E-mail", password: "Adgangskode", login: "Log ind", forgotPassword: "Glemt adgangskode?",
    dealer: "FORHANDLER", seller: "SAELGER",
    dashboard: "Oversigt", newCustomer: "Ny Kunde", myCustomers: "Mine Kunder", sellers: "Saelgere", backOffice: "Back-Office", report: "Rapport", manuals: "Manualer", security: "Sikkerhed",
    // Customer-list scope (Fabrizio CR 26/02/2026)
    scopeMineLabel: "Kun mine", scopeAllLabel: "Alle hos forhandleren", assignedTo: "Tildelt til", assignedToManager: "Manager-kunde",
    totalCustomers: "Samlede Kunder", emailsSent: "E-mails Sendt", termsAccepted: "Vilkar Accepteret", contractsSigned: "Kontrakter Underskrevet", cardsCreated: "Kort Oprettet", last30days: "Sidste 30 dage",
    startAdding: "Begynd med at tilfoeje en ny kunde", monthlyTarget: "Manedligt Mal", targetReached: "Mal naet! Godt gaaet!", remainingClients: "kunder til malet",
    leaderboard: "Rangliste", youAreAt: "Du er pa", place: "plads", you: "Dig", clients: "kunder", contracts: "kontrakter",
    weeklyDigest: "Ugentlig Oversigt", digestDescription: "Modtag en oversigt via e-mail hver mandag kl 8:00", sendPreview: "Send Forhaandsvisning", sending: "Sender...",
    digestEnabled: "Ugentlig oversigt aktiveret", digestDisabled: "Ugentlig oversigt deaktiveret", digestSent: "Forhaandsvisning sendt til din e-mail!",
    phone: "Mobil", vehicleBrand: "Koeretoejsmaerke", vehicleModel: "Koeretoejsmodel", vin: "VIN (Chassis)", vrn: "Nummerplade", country: "Land", serviceType: "LJ-tjeneste",
    verifyAndCreate: "Verificer og Opret Kunde", creating: "Opretter...",
    confirmTitle: "Bekraeft Kundedata", confirmSubtitle: "Kontroller dataene inden du fortsaetter:", brand: "Maerke", model: "Model", service: "Tjeneste",
    edit: "Rediger", confirmAndSend: "Bekraeft og Send",
    customerCreated: "Kunde oprettet! Velkomst-e-mail sendt.", createError: "Oprettelsesfejl", vinAlreadyEnrolled: "VIN allerede registreret i systemet",
    refresh: "Opdater", noCustomers: "Ingen kunder tilfojet", signed: "Underskrevet", card: "Kort",
    newSeller: "Ny Saelger", addSeller: "Tilfoej Saelger", close: "Luk",
    sellerEmailInfo: "Saelgeren modtager en e-mail med et link til at oprette adgangskode.",
    firstName: "Fornavn", lastName: "Efternavn", phoneSeller: "Telefon", department: "Afdeling",
    createSeller: "Opret Saelger og Send E-mail", noSellers: "Ingen saelgere registreret",
    clickToAdd: "Klik \"Ny Saelger\" for at tilfoeje et teammedlem.",
    sellerCreated: "Saelger oprettet! Aktiverings-e-mail sendt.", sellerCreateError: "Fejl ved oprettelse af saelger",
    activation: "Aktivering", active: "Aktiv", pending: "Afventer", deactivated: "Konto deaktiveret",
    sellerActivated: "Saelger aktiveret", sellerDeactivated: "Saelger deaktiveret",
    activationResent: "Aktiverings-e-mail gensendt!", deleteSeller: "Slet saelger", deleteConfirm: "Denne handling er irreversibel.", sellerDeleted: "Saelger slettet",
    newBackOffice: "Ny Back-Office", addBackOffice: "Tilfoej Back-Office",
    createBackOffice: "Opret Back-Office og Send E-mail",
    backOfficeEmailInfo: "Back-Office-brugeren modtager en e-mail med et link til at oprette adgangskode. Back-Office-brugere kan registrere kunder pa vegne af saelgere og overvage alle kontrakter, men vises ikke i \"Tildelt saelger\"-listen og ser ikke praestationsstatistikker.",
    backOfficeCreated: "Back-Office-bruger oprettet! Aktiverings-e-mail sendt.",
    noBackOffice: "Ingen Back-Office-brugere registreret",
    clickToAddBackOffice: "Klik \"Ny Back-Office\" for at tilfoeje administrativt personale.",
    sellersReport: "Saelgerrapport", globalTarget: "Globalt Manedligt Mal", globalTargetDesc: "Standardmal for alle saelgere (kan tilsidesaettes individuelt)",
    clientsMonth: "kunder/maned", target: "Mal", monthProgress: "Manedsfremdrift", total: "Samlet",
    performanceBySeller: "Prastation per Saelger", noTarget: "Intet mal",
    targetUpdated: "Globalt mal opdateret", customTarget: "Tilpasset mal", targetRemoved: "Mal fjernet (bruger globalt)",
    directCustomers: "Direkte Kunder", sellerCount: "Saelgere",
    monthlyLeaderboard: "Manedlig Rangliste", noSellersReport: "Ingen saelgere registreret til rapportgenerering.",
    loadingReport: "Indlaeser rapport...", clickRefresh: "Klik \"Opdater\" for at indlaese rapporten.",
    notifications: "Notifikationer", markAllRead: "Marker alle som laest", noNotifications: "Ingen notifikationer",
    loginError: "Loginfejl", saveError: "Gemfejl", sendError: "Sendefejl", toggleError: "Skiftefejl", deleteError: "Slettefejl",
    // ─── auto-translated 2026-06-23 (UI fallback rescue) ───
    enterValidNumber: "Indtast et gyldigt nummer",
    vinAlreadyEnrolledTitle: "VIN allerede registreret",
    vinAlreadyEnrolledBody: "VIN {vin} er allerede registreret i systemet. Et koeretoj kan ikke vaere tilknyttet to forskellige kunder.",
    existingCustomerLabel: "Eksisterende kunde",
    createdOnLabel: "Oprettet den",
    contractStatusLabel: "Kontrakt",
    signedLabel: "Underskrevet",
    pendingSignatureLabel: "Afventer underskrift",
    vinDupeOtherDealer: "Koeretoejet er registreret hos en anden forhandler. Kontakt LoJack support hvis du mener dette er en fejl.",
    changeVinBtn: "Rediger VIN",
    openExistingCustomerBtn: "Abn kundeoplysninger",
    walletQrTitle: "Wallet link - QR klar til visning",
    walletQrSmsModeBody: "Kunden i dette land modtager kortet via SMS. Vis denne QR til kunden for straks at abne wallet pa telefonen - uden at vente pa beskeden.",
    walletQrBothModeBody: "Email og SMS sendt. Hvis kunden er til stede, kan QR-koden scannes for at abne kortet med det samme.",
    walletQrShortLinkLabel: "Kort link (til WhatsApp / chat)",
    walletQrCopied: "Link kopieret",
    walletQrCopyBtn: "Kopier",
    walletQrSmsRecipient: "SMS sendt til",
    walletQrEmailRecipient: "Email sendt til",
    walletQrDoneBtn: "Luk",
    cannotDeleteContractSigned: "Kan ikke slettes: kontrakt allerede underskrevet",
    confirmDeleteCustomer: "Slet kunde {name} ({email})?",
    customerDeletedSuccess: "Kunde slettet",
    customerDeleteError: "Fejl ved sletning af kunde",
    contractNotSignedYet: "Kontrakt endnu ikke underskrevet af kunden",
    signedPdfDownloaded: "Underskrevet PDF downloadet",
    signedPdfDownloadError: "Fejl ved download af underskrevet PDF",
    viewSignedReadonly: "Vis data (underskrevet, kun laesning)",
    editCustomer: "Rediger kunde",
    downloadSignedPdf: "Download underskrevet kontrakt (PDF)",
    deleteCustomerOnlyUnsigned: "Slet kunde (kun hvis ikke underskrevet)",
    vinApplied: "VIN genkendt",
    phoneCountryMismatchTitle: "Nummer fra andet land registreret",
    phoneCountryMismatchBody: "Telefon landekoden indikerer en kunde fra {detected}, men kundens land er i oejeblikket {current}. Vil du opdatere?",
    phoneCountrySwitchedTo: "Kundeland opdateret:",
    phoneCountrySwitchTo: "Indstil land til {detected}",
    vatCountryMismatchTitle: "Moms-nr. fra andet land registreret",
    vatCountryMismatchBody: "Moms-nr. praefiks indikerer en kunde fra {detected}, men kundens land er i oejeblikket {current}. Vil du opdatere?",
    vatCountrySwitchedTo: "Kundeland opdateret:",
    vatCountrySwitchTo: "Indstil land til {detected}",
    vehicleOriginLabel: "Koeretoj",
    vinAutoApplied: "Koeretoj genkendt  udfyldt automatisk",
    vinEditable: "Felterne Maerke og Model kan stadig redigeres.",
    vrnOptional: "Valgfrit felt",
    sellerCreditedLabel: "Tilknyttet saelger",
    sellerCreditedPlaceholder: "Vaelg saelger...",
    sellerCreditedManagerSuffix: "Indehaver",
    sellerCreditedHintNoSellers: "Du har endnu ikke tilfojet saelgere. Du kan tildele denne kunde til dig selv eller oprette en fra fanen \"Saelgere\".",
    deactivateAction: "Deaktiver",
    activateAction: "Aktiver",
    salesTeamPlaceholder: "f.eks. Salg Nord",
    resendActivationEmail: "Send aktiveringsmail igen",
    deleteAction: "Slet",
    manual: "Brugermanual",
    mismatchSourceVat: "fra moms-nr.",
    mismatchSourcePhone: "fra telefon",
    mismatchCorrectionReasonDefault: "Rettet fra Mismatch widget (forhandler)",
    mismatchCountryUpdated: "Land opdateret:",
    mismatchCorrectionFailed: "Rettelsefejl",
    mismatchCleanTitle: "Landedatakvalitet:  Godt arbejde",
    mismatchCleanBody: "Alle {n} kunder fra de seneste 30 dage har land i overensstemmelse med moms-nr./telefon.",
    mismatchTitle: "Kunder med land der skal gennemgas",
    mismatchBodyIntro: "I de seneste 30 dage har du oprettet",
    mismatchBodyMiddle: "kunder, hvoraf",
    mismatchBodyEnd: "har et andet land end det foreslag fra moms-nr. eller telefon landekode. Ret med et klik.",
    mismatchCurrent: "Nuvaerende:",
    mismatchFixBtn: "Ret",
    mismatchConfirmQuestion: "Bekraeft aendring af land til",
    mismatchReasonPlaceholder: "Rettelsesgrund (valgfrit)",
    mismatchSaving: "Gemmer...",
    mismatchConfirmFix: "Bekraeft rettelse",
    mismatchCancel: "Annuller",
    language: "Sprog", poweredBy: "Powered by TelcaVoIP AI Engine",
  },
  CZ: {
    portalTitle: "Portal Prodejce", loginSubtitle: "Prihlas se pro spravu zakazniku", email: "E-mail", password: "Heslo", login: "Prihlasit", forgotPassword: "Zapomenute heslo?",
    dealer: "PRODEJCE", seller: "OBCHODNIK",
    dashboard: "Prehled", newCustomer: "Novy Zakaznik", myCustomers: "Moji Zakaznici", sellers: "Obchodnici", backOffice: "Back-Office", report: "Report", manuals: "Manualy", security: "Zabezpeceni",
    // Customer-list scope (Fabrizio CR 26/02/2026)
    scopeMineLabel: "Pouze moji", scopeAllLabel: "Všichni prodejce", assignedTo: "Přiřazeno", assignedToManager: "Zákazník manažera",
    totalCustomers: "Celkem Zakazniku", emailsSent: "Odeslane E-maily", termsAccepted: "Podminky Prijaty", contractsSigned: "Smlouvy Podepsany", cardsCreated: "Karty Vytvoreny", last30days: "Poslednich 30 dni",
    startAdding: "Zacnete pridanim noveho zakaznika", monthlyTarget: "Mesicni Cil", targetReached: "Cil splnen! Skvela prace!", remainingClients: "zakazniku do cile",
    leaderboard: "Zebricek", youAreAt: "Jste na", place: "miste", you: "Vy", clients: "zakazniku", contracts: "smluv",
    weeklyDigest: "Tydenni Souhrn", digestDescription: "Prijmejte souhrn e-mailem kazde pondeli v 8:00", sendPreview: "Odeslat Nahled", sending: "Odesila se...",
    digestEnabled: "Tydenni souhrn aktivovan", digestDisabled: "Tydenni souhrn deaktivovan", digestSent: "Nahled odeslan na vas e-mail!",
    phone: "Mobil", vehicleBrand: "Znacka Vozidla", vehicleModel: "Model Vozidla", vin: "VIN (Podvozek)", vrn: "SPZ", country: "Zeme", serviceType: "LJ Sluzba",
    verifyAndCreate: "Overit a Vytvorit Zakaznika", creating: "Vytvareni...",
    confirmTitle: "Potvrdit Udaje Zakaznika", confirmSubtitle: "Zkontrolujte udaje pred pokracovanim:", brand: "Znacka", model: "Model", service: "Sluzba",
    edit: "Upravit", confirmAndSend: "Potvrdit a Odeslat",
    customerCreated: "Zakaznik vytvoren! Uvitaci e-mail odeslan.", createError: "Chyba vytvareni", vinAlreadyEnrolled: "VIN je jiz registrovano v systemu",
    refresh: "Obnovit", noCustomers: "Zadni zakaznici", signed: "Podepsano", card: "Karta",
    newSeller: "Novy Obchodnik", addSeller: "Pridat Obchodnika", close: "Zavrit",
    sellerEmailInfo: "Obchodnik obdrzi e-mail s odkazem pro vytvoreni hesla.",
    firstName: "Jmeno", lastName: "Prijmeni", phoneSeller: "Telefon", department: "Oddeleni",
    createSeller: "Vytvorit Obchodnika a Odeslat E-mail", noSellers: "Zadni registrovani obchodnici",
    clickToAdd: "Kliknete \"Novy Obchodnik\" pro pridani clena tymu.",
    sellerCreated: "Obchodnik vytvoren! Aktivacni e-mail odeslan.", sellerCreateError: "Chyba pri vytvareni obchodnika",
    activation: "Aktivace", active: "Aktivni", pending: "Ceka", deactivated: "Ucet deaktivovan",
    sellerActivated: "Obchodnik aktivovan", sellerDeactivated: "Obchodnik deaktivovan",
    activationResent: "Aktivacni e-mail znovu odeslan!", deleteSeller: "Smazat obchodnika", deleteConfirm: "Tuto akci nelze vratit.", sellerDeleted: "Obchodnik smazan",
    newBackOffice: "Novy Back-Office", addBackOffice: "Pridat Back-Office",
    createBackOffice: "Vytvorit Back-Office a Odeslat E-mail",
    backOfficeEmailInfo: "Uzivatel Back-Office obdrzi e-mail s odkazem pro vytvoreni hesla. Uzivatele Back-Office mohou registrovat zakazniky jmenem obchodniku a sledovat vsechny smlouvy, ale neobjevuji se v rozbalovacim menu \"Prirazeny obchodnik\" ani nevidi statistiky vykonu.",
    backOfficeCreated: "Uzivatel Back-Office vytvoren! Aktivacni e-mail odeslan.",
    noBackOffice: "Zadni registrovani uzivatele Back-Office",
    clickToAddBackOffice: "Kliknete \"Novy Back-Office\" pro pridani administrativniho personalu.",
    sellersReport: "Report Obchodniku", globalTarget: "Globalni Mesicni Cil", globalTargetDesc: "Vychozi cil pro vsechny obchodniky (lze prepsat individualne)",
    clientsMonth: "zakazniku/mesic", target: "Cil", monthProgress: "Postup Mesice", total: "Celkem",
    performanceBySeller: "Vykon Obchodnika", noTarget: "Zadny cil",
    targetUpdated: "Globalni cil aktualizovan", customTarget: "Vlastni cil", targetRemoved: "Cil odstranen (pouziva globalni)",
    directCustomers: "Primri Zakaznici", sellerCount: "Obchodnici",
    monthlyLeaderboard: "Mesicni Zebricek", noSellersReport: "Zadni obchodnici pro generovani reportu.",
    loadingReport: "Nacitani reportu...", clickRefresh: "Kliknete \"Obnovit\" pro nacteni reportu.",
    notifications: "Oznameni", markAllRead: "Oznacit vse jako prectene", noNotifications: "Zadna oznameni",
    loginError: "Chyba prihlaseni", saveError: "Chyba ukladani", sendError: "Chyba odeslani", toggleError: "Chyba prepnuti", deleteError: "Chyba mazani",
    // ─── auto-translated 2026-06-23 (UI fallback rescue) ───
    enterValidNumber: "Zadejte platne cislo",
    vinAlreadyEnrolledTitle: "VIN jiz registrovan",
    vinAlreadyEnrolledBody: "VIN {vin} je jiz registrovan v systemu. Vozidlo nemuze byt prirazen dvema ruznymi zakaznikum.",
    existingCustomerLabel: "Existujici zakaznik",
    createdOnLabel: "Vytvoreno",
    contractStatusLabel: "Smlouva",
    signedLabel: "Podepsano",
    pendingSignatureLabel: "Ceka na podpis",
    vinDupeOtherDealer: "Vozidlo je registrovano u jineho prodejce. Kontaktujte podporu LoJack, pokud se domnivaete, ze jde o chybu.",
    changeVinBtn: "Zmenit VIN",
    openExistingCustomerBtn: "Otevrit kartu zakaznika",
    walletQrTitle: "Odkaz wallet  QR pripraven k zobrazeni",
    walletQrSmsModeBody: "Zakaznik v teto zemi obdrzi kartu pres SMS. Ukazte tento QR zakaznikovi pro okamzite otevreni wallet na jeho telefonu  bez cekani na zpravu.",
    walletQrBothModeBody: "Email a SMS odeslany. Pokud je zakaznik protomu, muze naskenovat tento QR pro okamzite otevreni karty.",
    walletQrShortLinkLabel: "Kratky odkaz (pro WhatsApp / chat)",
    walletQrCopied: "Odkaz zkopirovan",
    walletQrCopyBtn: "Kopirovat",
    walletQrSmsRecipient: "SMS odeslana na",
    walletQrEmailRecipient: "Email odeslan na",
    walletQrDoneBtn: "Zavrit",
    cannotDeleteContractSigned: "Nelze smazat: smlouva jiz podepsana",
    confirmDeleteCustomer: "Smazat zakaznika {name} ({email})?",
    customerDeletedSuccess: "Zakaznik smazan",
    customerDeleteError: "Chyba pri mazani zakaznika",
    contractNotSignedYet: "Smlouva jeste neni zakaznikem podepsana",
    signedPdfDownloaded: "Podepsany PDF stazen",
    signedPdfDownloadError: "Chyba pri stazeni podepsaneho PDF",
    viewSignedReadonly: "Zobrazit udaje (podepsano, jen pro cteni)",
    editCustomer: "Upravit zakaznika",
    downloadSignedPdf: "Stahnout podepsanou smlouvu (PDF)",
    deleteCustomerOnlyUnsigned: "Smazat zakaznika (pouze pokud neni podepsano)",
    vinApplied: "VIN rozpoznan",
    phoneCountryMismatchTitle: "Zjisteno cislo z jine zeme",
    phoneCountryMismatchBody: "Telefonni predvolba naznacuje zakaznika {detected}, ale zeme zakaznika je aktualne {current}. Chcete ji aktualizovat?",
    phoneCountrySwitchedTo: "Zeme zakaznika aktualizovana:",
    phoneCountrySwitchTo: "Nastavit zemi na {detected}",
    vatCountryMismatchTitle: "Zjisteno DIC z jine zeme",
    vatCountryMismatchBody: "Predpona DIC naznacuje zakaznika {detected}, ale zeme zakaznika je aktualne {current}. Chcete ji aktualizovat?",
    vatCountrySwitchedTo: "Zeme zakaznika aktualizovana:",
    vatCountrySwitchTo: "Nastavit zemi na {detected}",
    vehicleOriginLabel: "Vozidlo",
    vinAutoApplied: "Vozidlo rozpoznano  vyplneno automaticky",
    vinEditable: "Pole Znacka a Model jsou i tak upravitelna.",
    vrnOptional: "Nepovinne pole",
    sellerCreditedLabel: "Prirazen prodejce",
    sellerCreditedPlaceholder: "Vyberte prodejce...",
    sellerCreditedManagerSuffix: "Majitel",
    sellerCreditedHintNoSellers: "Jeste jste nepridali zadne prodejce. Muzete priradit tohoto zakaznika sobe nebo vytvorit prodejce v zalozce \"Prodejci\".",
    deactivateAction: "Deaktivovat",
    activateAction: "Aktivovat",
    salesTeamPlaceholder: "napr. Prodej Sever",
    resendActivationEmail: "Znovu odeslat email aktivace",
    deleteAction: "Smazat",
    manual: "Provozni prirucka",
    mismatchSourceVat: "z DIC",
    mismatchSourcePhone: "z telefonu",
    mismatchCorrectionReasonDefault: "Opraveno widgetem Mismatch (prodejce)",
    mismatchCountryUpdated: "Zeme aktualizovana:",
    mismatchCorrectionFailed: "Chyba opravy",
    mismatchCleanTitle: "Kvalita udaju zeme:  Vyborne",
    mismatchCleanBody: "Vsech {n} zakazniku za poslednich 30 dni ma zemi shodnou s DIC/telefonem.",
    mismatchTitle: "Zakaznici se zemi k overeni",
    mismatchBodyIntro: "Za poslednich 30 dni jste vytvorili",
    mismatchBodyMiddle: "zakazniku, z nichz",
    mismatchBodyEnd: "ma jinou zemi, nez navrhovano DIC nebo telefonni predvolbou. Opravte jednim kliknutim.",
    mismatchCurrent: "Aktualni:",
    mismatchFixBtn: "Opravit",
    mismatchConfirmQuestion: "Potvrdit zmenu zeme na",
    mismatchReasonPlaceholder: "Duvod opravy (nepovinne)",
    mismatchSaving: "Ukladani...",
    mismatchConfirmFix: "Potvrdit opravu",
    mismatchCancel: "Zrusit",
    language: "Jazyk", poweredBy: "Powered by TelcaVoIP AI Engine",
  },
  GR: {
    portalTitle: "Portal Antiprosopou", loginSubtitle: "Syndethite gia na diaheiristite tous pelates sas", email: "Email", password: "Kodikos", login: "Syndesi", forgotPassword: "Xehasate ton kodiko?",
    dealer: "ANTIPROSOPOS", seller: "POLITIS",
    dashboard: "Pinakes", newCustomer: "Neos Pelatis", myCustomers: "Oi Pelates Mou", sellers: "Polites", backOffice: "Back-Office", report: "Anafora", manuals: "Egheiridio", security: "Asfaleia",
    // Customer-list scope (Fabrizio CR 26/02/2026)
    scopeMineLabel: "Μόνο οι δικοί μου", scopeAllLabel: "Όλοι του dealer", assignedTo: "Ανατεθειμένος σε", assignedToManager: "Πελάτης διευθυντή",
    totalCustomers: "Synoliko Pelaton", emailsSent: "Email Stalthikan", termsAccepted: "Oroi Apodektoi", contractsSigned: "Symvasia Ypografikan", cardsCreated: "Kartes Dimiourgithikan", last30days: "Teleftaies 30 meres",
    startAdding: "Xekiniste prosthetnontas enan neo pelati", monthlyTarget: "Minieos Stohos", targetReached: "Stohos epiteuhthike! Exairetiko!", remainingClients: "pelates gia ton stoho",
    leaderboard: "Katataxi", youAreAt: "Eiste sti", place: "thesi", you: "Eseis", clients: "pelates", contracts: "symvaseis",
    weeklyDigest: "Evdomadiaio Periligitiko", digestDescription: "Lambante periligitiko me email kathe Deftera stis 8:00", sendPreview: "Apostoli Proepiskopisis", sending: "Apostoli...",
    digestEnabled: "Evdomadiaio periligitiko energopoiithike", digestDisabled: "Evdomadiaio periligitiko apenoeropoiithike", digestSent: "Proepiskopisi stalthike sto email sas!",
    phone: "Kinito", vehicleBrand: "Marka Ohimatos", vehicleModel: "Montelo Ohimatos", vin: "VIN (Plaisio)", vrn: "Pinakida", country: "Hora", serviceType: "Ypiresia LJ",
    verifyAndCreate: "Epivevaioste kai Dimiourgiste Pelati", creating: "Dimiourgia...",
    confirmTitle: "Epivevaioste ta Dedomena", confirmSubtitle: "Elegxte ta dedomena prin synehisete:", brand: "Marka", model: "Montelo", service: "Ypiresia",
    edit: "Epexergasia", confirmAndSend: "Epivevaioste kai Steilte",
    customerCreated: "Pelatis dimiourgithike! Email kalosirismatos stalthike.", createError: "Sfalma dimiourgias", vinAlreadyEnrolled: "VIN idi katachorimeno sto systima",
    refresh: "Ananeoste", noCustomers: "Den yparhoun pelates", signed: "Ypografike", card: "Karta",
    newSeller: "Neos Politis", addSeller: "Prostheste Politi", close: "Kleisimo",
    sellerEmailInfo: "O politis tha lavei email me syndesmo gia dimiourgia kodikou.",
    firstName: "Onoma", lastName: "Eponimo", phoneSeller: "Tilefono", department: "Tmima",
    createSeller: "Dimiourgia Politi kai Apostoli Email", noSellers: "Den yparhoun eggegramenoi polites",
    clickToAdd: "Kaneteklik \"Neos Politis\" gia na prosthesete melos tis omadas.",
    sellerCreated: "Politis dimiourgithike! Email energopoiisis stalthike.", sellerCreateError: "Sfalma dimiourgias politi",
    activation: "Energopoiisi", active: "Energos", pending: "Ekkremei", deactivated: "Logariasmos apenoeropoiithike",
    sellerActivated: "Politis energopoiithike", sellerDeactivated: "Politis apenoeropoiithike",
    activationResent: "Email energopoiisis xanastalthike!", deleteSeller: "Diagrafi politi", deleteConfirm: "Afti i energeia einai mi anastresimi.", sellerDeleted: "Politis diagraftike",
    newBackOffice: "Neo Back-Office", addBackOffice: "Prostheste Back-Office",
    createBackOffice: "Dimiourgia Back-Office kai Apostoli Email",
    backOfficeEmailInfo: "O hristis Back-Office tha lavei email me syndesmo gia dimiourgia kodikou. Oi hristes Back-Office mporoun na katahoroun pelates ek meroys ton politon kai na parakolouthoun oles tis symvaseis, alla den emfanizontai sto dropdown \"Synergaisomenos politis\" oute vlepoun statistika apodosis.",
    backOfficeCreated: "Hristis Back-Office dimiourgithike! Email energopoiisis stalthike.",
    noBackOffice: "Den yparhoun eggegramenoi hristes Back-Office",
    clickToAddBackOffice: "Kanete klik \"Neo Back-Office\" gia na prosthesete dioikitiko prosopiko.",
    sellersReport: "Anafora Politon", globalTarget: "Genikos Minieos Stohos", globalTargetDesc: "Proepilogi stohoy gia olous tous polites (dynaton na antikatastathei)",
    clientsMonth: "pelates/mina", target: "Stohos", monthProgress: "Proodos Mina", total: "Synolo",
    performanceBySeller: "Apodosi ana Politi", noTarget: "Horis stoho",
    targetUpdated: "Genikos stohos enimerothike", customTarget: "Prosarmosmenos stohos", targetRemoved: "Stohos afairethike (hrisimopoiei geniko)",
    directCustomers: "Amesoi Pelates", sellerCount: "Polites",
    monthlyLeaderboard: "Miniaia Katataxi", noSellersReport: "Den yparhoun polites gia dimiourgia anaforas.",
    loadingReport: "Fortosi anaforas...", clickRefresh: "Kanete klik \"Ananeoste\" gia fortosi tis anaforas.",
    notifications: "Eidopoiiseis", markAllRead: "Simadefte oles os anagnosmenes", noNotifications: "Den yparhoun eidopoiiseis",
    loginError: "Sfalma syndesis", saveError: "Sfalma apothikeysis", sendError: "Sfalma apostolis", toggleError: "Sfalma enallaxis", deleteError: "Sfalma diagrafis",
    // ─── auto-translated 2026-06-23 (UI fallback rescue) ───
    enterValidNumber: "Eisagete enan egkyro arithmo",
    vinAlreadyEnrolledTitle: "VIN idi katachorimeno",
    vinAlreadyEnrolledBody: "To VIN {vin} einai idi katachorimeno sto systima. Ena ochima den mporei na syndethei me dyo diaforetikous pelates.",
    existingCustomerLabel: "Yparxon pelatis",
    createdOnLabel: "Dimiourgithike",
    contractStatusLabel: "Symvolaio",
    signedLabel: "Ypogrammeno",
    pendingSignatureLabel: "Anamoni ypografis",
    vinDupeOtherDealer: "To ochima einai katachorimeno se allo antiproswpo. Epikoinoniste me tin ypostiriksi LoJack an pistevete oti einai lathos.",
    changeVinBtn: "Allaxe VIN",
    openExistingCustomerBtn: "Anoixe fakelo pelati",
    walletQrTitle: "Link wallet  QR etoimo gia provoli",
    walletQrSmsModeBody: "O pelatis se afti ti chora lamvanei tin karta meso SMS. Deixte afto to QR ston pelati gia na anoixei amesos to wallet sto kinito tou  choris na perimenei to minima.",
    walletQrBothModeBody: "Email kai SMS stalthikan. An o pelatis einai mprosta sas, mporei na skanar afto to QR gia na anoixei tin karta amesos.",
    walletQrShortLinkLabel: "Syntomos syndesmos (gia WhatsApp / chat)",
    walletQrCopied: "Syndesmos antigrafik",
    walletQrCopyBtn: "Antigrapse",
    walletQrSmsRecipient: "SMS stalthike se",
    walletQrEmailRecipient: "Email stalthike se",
    walletQrDoneBtn: "Kleise",
    cannotDeleteContractSigned: "Adynati diagrafi: symvolaio idi ypogrammeno",
    confirmDeleteCustomer: "Diagrafi pelati {name} ({email})?",
    customerDeletedSuccess: "Pelatis diagrafike",
    customerDeleteError: "Sfalma diagrafis pelati",
    contractNotSignedYet: "Symvolaio den exei ypografei akoma apo ton pelati",
    signedPdfDownloaded: "Ypogrammeno PDF katevas",
    signedPdfDownloadError: "Sfalma katevasmatos ypogrammenou PDF",
    viewSignedReadonly: "Provoli dedomenon (ypogrammeno, mono anagnosi)",
    editCustomer: "Epexergasia pelati",
    downloadSignedPdf: "Katevase ypogrammeno symvolaio (PDF)",
    deleteCustomerOnlyUnsigned: "Diagrapse pelati (mono an den exei ypografei)",
    vinApplied: "VIN anagnorismeno",
    phoneCountryMismatchTitle: "Anixneythike arithmos allis choras",
    phoneCountryMismatchBody: "O kodikos tilefonou deixnei pelati {detected}, alla i chora tou pelati einai {current}. Thelte na to enieroset?",
    phoneCountrySwitchedTo: "Chora pelati enimerose:",
    phoneCountrySwitchTo: "Oriste chora se {detected}",
    vatCountryMismatchTitle: "Anixneythike P.IVA allis choras",
    vatCountryMismatchBody: "O kodikos tis P.IVA deixnei pelati {detected}, alla i chora tou pelati einai {current}. Thelete na to enieroset?",
    vatCountrySwitchedTo: "Chora pelati enimerose:",
    vatCountrySwitchTo: "Oriste chora se {detected}",
    vehicleOriginLabel: "Ochima",
    vinAutoApplied: "Ochima anagnorismeno  symplirose aftomata",
    vinEditable: "Ta pedia Marka kai Montelo einai panta tropopoiisima.",
    vrnOptional: "Pedio proairetiko",
    sellerCreditedLabel: "Syndedmenos politis",
    sellerCreditedPlaceholder: "Epilexte ton politi...",
    sellerCreditedManagerSuffix: "Ypefthynos",
    sellerCreditedHintNoSellers: "Den exete prosthesei akoma polites. Mporeit na apodosete afton ton pelati ston eafto sas i na dimiourgisete enan apo tin kartel \"Polites\".",
    deactivateAction: "Apenergopoiise",
    activateAction: "Energopoiise",
    salesTeamPlaceholder: "p.x. Poliseis Vorra",
    resendActivationEmail: "Epanastoli email energopoiisis",
    deleteAction: "Diagrapse",
    manual: "Egcheiridio Cheirismou",
    mismatchSourceVat: "apo P.IVA",
    mismatchSourcePhone: "apo tilefono",
    mismatchCorrectionReasonDefault: "Diorthothike apo to widget Mismatch (antiprosopos)",
    mismatchCountryUpdated: "Chora enimerose:",
    mismatchCorrectionFailed: "Sfalma diorthosis",
    mismatchCleanTitle: "Poiotita dedomenon choras:  Yperochi douleia",
    mismatchCleanBody: "Oloi oi {n} pelates ton teleftaion 30 imeron exoun chora synep me P.IVA/tilefono.",
    mismatchTitle: "Pelates me chora pros elegxo",
    mismatchBodyIntro: "Tis teleftaies 30 imeres dimiourgisate",
    mismatchBodyMiddle: "pelates, apo tous opoious",
    mismatchBodyEnd: "exoun diaforetiki chora apo afti pou proteinetai apo tin P.IVA i ton kodiko tilefonou. Diorthose me ena klik.",
    mismatchCurrent: "Trechousa:",
    mismatchFixBtn: "Diorthose",
    mismatchConfirmQuestion: "Epivevaiosi allagis choras se",
    mismatchReasonPlaceholder: "Aitia diorthosis (proairetiko)",
    mismatchSaving: "Apothikefsi...",
    mismatchConfirmFix: "Epivevaiosi diorthosis",
    mismatchCancel: "Akyrosi",
    language: "Glossa", poweredBy: "Powered by TelcaVoIP AI Engine",
  },
  CH: { /* Swiss German - same as DE */ },
  GBZ: { /* Gibraltar English - same as UK */ },
  IRL: { /* Ireland English - same as UK */ },
  BE: { /* Belgian French - same as FR */ },
};

// Copy shared translations
DEALER_TRANSLATIONS.CH = { ...DEALER_TRANSLATIONS.DE };
DEALER_TRANSLATIONS.GBZ = { ...DEALER_TRANSLATIONS.UK };
DEALER_TRANSLATIONS.IRL = { ...DEALER_TRANSLATIONS.UK };
DEALER_TRANSLATIONS.BE = { ...DEALER_TRANSLATIONS.FR };

// Country code to language name mapping for the selector
export const LANGUAGE_OPTIONS = [
  { code: 'IT', label: 'Italiano' },
  { code: 'UK', label: 'English' },
  { code: 'FR', label: 'Francais' },
  { code: 'ES', label: 'Espanol' },
  { code: 'DE', label: 'Deutsch' },
  { code: 'NL', label: 'Nederlands' },
  { code: 'PT', label: 'Portugues' },
  { code: 'PL', label: 'Polski' },
  { code: 'SE', label: 'Svenska' },
  { code: 'NO', label: 'Norsk' },
  { code: 'FI', label: 'Suomi' },
  { code: 'DK', label: 'Dansk' },
  { code: 'CZ', label: 'Cestina' },
  { code: 'GR', label: 'Ellinika' },
  { code: 'CH', label: 'Schweizerdeutsch' },
  { code: 'GBZ', label: 'English (Gibraltar)' },
  { code: 'IRL', label: 'English (Ireland)' },
  { code: 'BE', label: 'Francais (Belgique)' },
];

// Get translation with UK-first shallow merge + CR i18n bundle overlay.
// Any key missing from the selected language falls back to UK-English
// (never Italian — mirrors the email pack policy after the 03/08/2026
// leak fix). The change-request bundle is layered last so that pack
// overrides win over the base dealer bundle.
export const getDealerTranslation = (langCode) => {
  const baseUK = DEALER_TRANSLATIONS['UK'] || {};
  const langPack = DEALER_TRANSLATIONS[langCode] || {};
  const crUK = CHANGE_REQUESTS_I18N ? (CHANGE_REQUESTS_I18N['UK'] || {}) : {};
  const crLang = CHANGE_REQUESTS_I18N ? (CHANGE_REQUESTS_I18N[langCode] || {}) : {};
  return { ...baseUK, ...langPack, ...crUK, ...crLang };
};

export default DEALER_TRANSLATIONS;
